$(function () {
    let hsId = getCookie("__hsID");
    let hsFirstName = getCookie("__hsFirstName");
    let hsLastName = getCookie("__hsLastName");

    let customerLogin = $('#customer_login');
    let customerForgot = $("#customer_forgot");
    let customerRegister = $("#create_customer");
    let accountCenter = $(".ego-account-center");
    let registration = $(".ego-c-register");
    let customerReset = $("#form-reset");

    if (registration.length || accountCenter.length) {
        $(".js-upload-file-label").click(function (e) {
            e.preventDefault();
            showUploadPicker();
        });
    }

    /* User Login */
    if (customerLogin.length) {
        customerLogin.validate({
            errorClass: 'ego-invalid',
            validClass: 'ego-valid',
            errorElement: 'span',
            errorPlacement: function (error, element) {
                error.addClass('ego-error-show');
                element.parent().append(error);
            },
            rules: {
                "customer[email]": {
                    required: true, email: true
                }, "customer[password]": {
                    required: true, minlength: 8
                }
            },
            messages: {
                "customer[email]": window.theme.custom.global.error.email,
                "customer[password]": window.theme.custom.global.error.password
            },
            submitHandler: function (form) {
                if (getCookie("recaptcha_bypass") === "recaptcha_bypass") {
                    reCAPTCHAResponseToken = "recaptcha_bypass";
                }

                if (grecaptcha.getResponse().length === 0 && reCAPTCHAResponseToken !== "recaptcha_bypass") {
                    alert(window.theme.custom.global.please_verify_that_you_are_not_a_robot_html);
                    return false;
                }

                if (reCAPTCHAResponseToken) {
                    loadingMask("show");
                    let _email = $('#main-login-email').val();

                    getApiPath('user/login').then(function (apiPath) {
                        let formDataLogin = {
                            brand_name: 'EGO',
                            user_info: {
                                auth: "Basic " + btoa(_email + ":" + $('#main-login-password').val()),
                                brand_name: 'EGOC',
                                email_address: _email,
                                event_type: "user_login",
                                hs_language: Shopify.locale,
                                method: "POST",
                                page_uri: window.location.href,
                                reCAPTCHA_token: reCAPTCHAResponseToken,
                                reCAPTCHA_location_lookup: "ego_commercial",
                                url: apiPath,
                                store_id: "1", //defaulting to EGO US
                                store_locale: Shopify.locale,
                                country: country,
                                region: locationInfo.Region
                            }
                        }

                        $.ajax({
                            method: 'POST',
                            url: apiURL + "rest/all/V1/chervon/proxy/account-processing/",
                            data: JSON.stringify(formDataLogin),
                            contentType: 'application/json',
                        })
                            .done(function (loginData) {
                                loginData = JSON.parse(loginData);
                                // proxy success
                                if (loginData.success) {//middleware success
                                    setTimeout(function () {
                                        setCookie('__auth', (loginData.message.header.Authorization || loginData.message.header.authorization).substring(7), 365, true);
                                        setCookie('__uid', loginData.message.body.customer_id, 365, true);
                                        setCookie('__acAuth', loginData.ac_auth, 365, true);
                                    }, 1);
                                    document.location = window.theme.custom.links.pages.account_center;
                                } else {
                                    if (loginData.hasOwnProperty("message")) {
                                        if (loginData.message.hasOwnProperty("type") && loginData.message.type === "recaptcha") { //google recaptcha error
                                            alert(window.theme.custom.global.error.generic_error);
                                            errorNotify('Proxy - EGO Commercial Login Failure (Google reCAPTCHA Error - Score too low or other possible error): ', JSON.stringify(loginData));
                                        } else if (loginData.message.hasOwnProperty("body") && loginData.message.body.hasOwnProperty("status")) { //heroku error
                                            switch (loginData.message.body.status) {
                                                case "402":
                                                case "404":
                                                    //402: Incorrect password.
                                                    //404: Can not find the account.
                                                    alert(window.theme.custom.login_page.error.incorrect_credentials);
                                                    break;
                                                case "428":
                                                    getApiPath('password/reset/create').then(function (apiPath) {
                                                        let formData = {
                                                            brand_name: 'EGO',
                                                            email_type: 'egocommercialreset',
                                                            email_address: $('#email').val()
                                                        }

                                                        $.ajax({
                                                            method: 'POST',
                                                            url: apiPath,
                                                            data: JSON.stringify(formData),
                                                            processData: false,
                                                            contentType: 'application/json'
                                                        })
                                                            .done(function (loginData, loginStatus, loginXHR) {
                                                                let title = "Welcome Back to EGO Power+";
                                                                let body = "<p>Since you last visited, we’ve been busy! ";
                                                                body += "We recently upgraded our system for a better user experience. ";
                                                                body += "In order to migrate your account to this new system, you’ll need to create a new password.</p><br/>";
                                                                body += "<p><b>We just sent you an email about how to reset your EGO password so we can migrate your account.</b></p><br/>";
                                                                body += "<p>The process should only take a minute or two—if you need any assistance, please feel free to <a href='contact-us'>contact us.</a></p>"

                                                                $('.ego-title').empty();
                                                                $('.ego-myaccount__form').empty();
                                                                $('.ego-title').html(title);
                                                                $('.ego-myaccount__form').html(body);

                                                                loadingMask("hide");
                                                            })
                                                            .fail(function (error) {
                                                                loadingMask("hide");
                                                                alert(window.theme.custom.global.error.generic_error);
                                                                errorNotify('Error: Ego Commercial Cannot create account', error);
                                                            });
                                                    }).catch(function (err) {
                                                        alert(window.theme.custom.global.error.generic_error);
                                                        errorNotify('Ego password/reset/create (standing login) Promise Catch: ' + err);
                                                        logout();
                                                    });
                                                    break;
                                                default:
                                                    alert(window.theme.custom.global.error.generic_error);
                                                    errorNotify("Heroku - EGO Commercial Login Failure (Standard Login Form - Middleware): " + loginData.message.body.message);
                                            }
                                        } else {
                                            alert(window.theme.custom.global.error.generic_error);
                                            errorNotify('Proxy - EGO Commercial Login Failure (Standard Login Form 2): ', JSON.stringify(loginData));
                                        }
                                    } else {
                                        alert(window.theme.custom.global.error.generic_error);
                                        errorNotify('Proxy - EGO Commercial Login Failure (Standard Login Form 1): ', JSON.stringify(loginData));
                                    }
                                    grecaptcha.reset();
                                    loadingMask("hide");
                                }
                            })
                            .fail(function (error) {
                                alert(window.theme.custom.global.error.generic_error);
                                errorNotify('Proxy Failure - EGO Commercial Login Failure (Standard Login Form): ' + error.responseText);
                                grecaptcha.reset();
                                loadingMask("hide");
                            });
                    }).catch(function (err) {
                        alert(window.theme.custom.global.error.generic_error);
                        errorNotify('Ego Commercial user/login (standard login) Promise Catch: ' + err);
                        grecaptcha.reset();
                        logout();
                    });
                }
            }
        });
    }

    /* User Forgot Password */
    if (customerForgot.length) {
        customerForgot.validate({
            errorClass: 'ego-invalid',
            validClass: 'ego-valid',
            errorElement: 'span',
            errorPlacement: function (error, element) {
                error.addClass('ego-error-show');
                element.parent().append(error);
            },
            submitHandler: function (event) {
                loadingMask("show");
                let formData = {
                    brand_name: 'EGO',
                    email_type: 'egocommercialreset',
                    email_address: $('#recoverEmail').val()
                }

                getApiPath('password/reset/create').then(function (apiPath) {
                    $.ajax({
                        method: 'POST',
                        url: apiPath,
                        data: JSON.stringify(formData),
                        processData: false,
                        contentType: 'application/json'
                    })
                        .done(function (loginData, loginStatus, loginXHR) {
                            $(".thb-login-form-form").fadeOut(function () {
                                $(".thb-login-form-recover-success").fadeIn();
                                loadingMask("hide");
                            });
                        })
                        .fail(function (error) {
                            loadingMask("hide");
                            if (error.status === 404) {
                                alert(window.theme.custom.recover_password.error);
                            }
                        });
                });
            },
            rules: {
                email: true
            },
            messages: {
                email: window.theme.custom.global.error.email
            }
        });
    }

    /* Reset Password */
    if (customerReset.length) {
        customerReset.each(function () {
            if (!document.URL.split('token=')[1]) {
                window.location.href = window.theme.custom.links.pages.account_login;
            }
        });

        customerReset.validate({
            errorClass: 'ego-invalid',
            validClass: 'ego-valid',
            errorElement: 'span',
            errorPlacement: function (error, element) {
                error.addClass('ego-error-show');
                element.parent().append(error);
            },
            rules: {
                password: {
                    minlength: 8,
                    "passwordValidationLetterNumberSpecialCharacter": true,
                },
                "confirm_password": {
                    minlength: 8,
                    equalTo: "#password"
                }
            },
            messages: {
                "password": {
                    required: window.theme.custom.global.error.password,
                    minlength: window.theme.custom.global.error.password_min_length
                },
                "confirm_password": {
                    required: window.theme.custom.global.error.confirm_password,
                    minlength: window.theme.custom.global.error.password_min_length,
                    equalTo: window.theme.custom.global.error.please_enter_the_same_value_again
                }
            },
            submitHandler: function (event) {
                loadingMask("show");
                getApiPath('password/reset').then(function(apiPath) {
                    var formData = {
                        password: $("#password").val(),
                        password_confirm: $('#confirm_password').val()
                    }

                    // Grab token part after "token="
                    let rawToken = document.URL.split('token=')[1];

                    // Decode any %xx encodings
                    let realToken = decodeURIComponent(rawToken);

                    $.ajax({
                        method: 'PATCH',
                        url: apiPath,
                        data: JSON.stringify(formData),
                        processData: false,
                        contentType: 'application/json',
                        headers: {
                            "Authorization": realToken
                        },
                    })
                        .done(function (loginData, loginStatus, loginXHR) {
                            $(".ego-account-reset .thb-form-container").fadeOut(function() {
                                $(".ego-account-reset .ego-account-reset-success").fadeIn();
                                loadingMask("hide");
                            });
                        })
                        .fail(function(error) {
                            loadingMask("hide");
                            if (error.status === 401) {
                                $(".ego-account-reset .thb-form-container").fadeOut(function() {
                                    $(".ego-account-reset .ego-account-reset-error").fadeIn();
                                });
                            } else {
                                alert(window.theme.custom.global.error.please_make_sure_the_password_follows_the_below_requirements + "\n\n" + window.theme.custom.global.error.must_contain_number_letter_spacial + "\n" + window.theme.custom.global.error.must_not_contain_name + "\n\n" + window.theme.custom.global.error.if_you_continue_having_issues_please_reach_out_to_support);
                                errorNotify('Ego Commercial Reset Password Reset Error', error.responseText);
                            }
                        });

                }).catch(function(err) {
                    alert(window.theme.custom.global.error.generic_error);
                    errorNotify('Ego password/reset Password Promise Catch: ' + err);
                    logout();
                });
            }
        });
    }

    /* User Create Account */
    if (customerRegister.length) {
        let createFormSubmitted = false;

        if (customerRegister.length) {
            let accountCreateFrom = $("#create_customer");

            $(".ego-c-selectmenu").on("selectmenuchange", function() {
                if (accountCreateFrom.hasClass("form-error")) {
                    accountCreateFrom.valid();
                }
            });

            customerRegister.validate({
                errorClass: 'ego-invalid',
                validClass: 'ego-valid',
                errorElement: 'span',
                ignore: [],
                errorPlacement: function (error, element) {
                    error.addClass('ego-error-show');

                    if (element.is("select")) {
                        error.insertAfter(element.next(".ui-selectmenu-button"))
                    } else {
                        element.parent().append(error);
                    }

                    accountCreateFrom.addClass("form-error");
                },
                rules: {
                    "customer[first_name]": {
                        lettersOnly: true,
                        preventonlywhitespace: true
                    }, "customer[last_name]": {
                        lettersOnly: true,
                        preventonlywhitespace: true
                    }, "customer[email]": {
                        customemailvalidation: true
                    }, "customer[password]": {
                        passwordValidationLetterNumberSpecialCharacter: true,
                        passwordValidationPreventNameMatch: true,
                    }, "customer[phone]": {
                        digits: true
                    }, "customer[business_type]": {
                        required: true
                    }
                },
                messages: {
                    "customer[first_name]": window.theme.custom.global.error.required,
                    "customer[last_name]": window.theme.custom.global.error.required,
                    "customer[email]": window.theme.custom.global.error.email,
                    "customer[password]": {
                        required: window.theme.custom.global.error.required,
                        minlength: window.theme.custom.global.error.password_min_length
                    },
                    "customer[phone]": {
                        minlength: window.theme.custom.global.error.password_min_length,
                        digits: window.theme.custom.global.error.please_enter_only_digits
                    },
                    "customer[business_type]": window.theme.custom.global.error.required,
                },
                submitHandler: function (form) {
                    if (getCookie("recaptcha_bypass") === "recaptcha_bypass") {
                        reCAPTCHAResponseToken = "recaptcha_bypass";
                    }

                    if (grecaptcha.getResponse().length === 0 && reCAPTCHAResponseToken !== "recaptcha_bypass") {
                        alert(window.theme.custom.global.please_verify_that_you_are_not_a_robot_html);
                        return false;
                    }

                    if (reCAPTCHAResponseToken) {
                        if (!createFormSubmitted) {
                            createFormSubmitted = true;
                            loadingMask("show");

                            getApiPath('user/create').then(function (apiPath) {
                                let first_name = titleCase($('#create_first_name').val());
                                let last_name = titleCase($('#create_last_name').val());
                                let email_address = $('#create_email').val().toLowerCase();
                                let mobile_phone = $('#create_phone').val();
                                let company = $('#create_company').val();
                                let marketing_opt_in = $('#create_opt_in').is(':checked');

                                let formDataCreate = {
                                    brand_name: 'EGO',
                                    first_name: first_name,
                                    last_name: last_name,
                                    email_address: email_address,
                                    password: $('#create_password').val(),
                                    mobile_phone: mobile_phone,
                                    marketing_opt_in: marketing_opt_in,
                                    site_origin: "United States",
                                    organization_name: company,
                                    customer_type: "Commercial",
                                    user_info: {
                                        brand_name: 'EGOC',
                                        first_name: first_name,
                                        last_name: last_name,
                                        email_address: email_address,
                                        ego_commercial_business_type: $('#create_business_type').val(),
                                        mobile_phone: mobile_phone,
                                        company: company,
                                        send_marketing_emails: marketing_opt_in,
                                        event_type: "account_create",
                                        method: "POST",
                                        hs_form_id: "c9f7090a-155e-4dd5-8c50-758046770f95",
                                        hs_language: Shopify.locale,
                                        hs_hubspotutk: getCookie('hubspotutk'),
                                        page_name: $("meta[name='title']").attr('content'),
                                        page_uri: window.location.href,
                                        form_url: window.location.origin + window.location.pathname,
                                        reCAPTCHA_token: reCAPTCHAResponseToken,
                                        reCAPTCHA_location_lookup: "ego_commercial",
                                        url: apiPath,
                                        ipAddress: locationInfo.IpAddress,
                                        store_id: "1", //defaulting to EGO US
                                        store_locale: Shopify.locale
                                    }
                                }

                                $.ajax({
                                    method: 'POST',
                                    url: apiURL + "rest/all/V1/chervon/proxy/account-processing/",
                                    data: JSON.stringify(formDataCreate), contentType: 'application/json'
                                })
                                    .done(function (createData) {
                                        createData = JSON.parse(createData);
                                        // proxy success
                                        if (createData.success) {//middleware success
                                            getApiPath('user/login').then(function (apiPath) {
                                                sessionStorage.setItem("hs_name_update_event_sent", "true");

                                                // ok it worked, so let's log in
                                                let formDataLogin = {
                                                    brand_name: 'EGO',
                                                    user_info: {
                                                        auth: "Basic " + btoa(formDataCreate['email_address'] + ":" + formDataCreate['password']),
                                                        event_type: "user_login_post_create",
                                                        method: "POST",
                                                        url: apiPath,
                                                        store_id: "1", //defaulting to EGO US
                                                        store_locale: Shopify.locale
                                                    }
                                                }

                                                $.ajax({
                                                    method: 'POST',
                                                    url: apiURL + "rest/all/V1/chervon/proxy/account-processing/",
                                                    data: JSON.stringify(formDataLogin),
                                                    contentType: 'application/json'
                                                })
                                                    .done(function (loginData) {
                                                        loginData = JSON.parse(loginData);
                                                        if (loginData.success) {//middleware success
                                                            setTimeout(function () {
                                                                setCookie('__auth', (loginData.message.header.Authorization || loginData.message.header.authorization).substring(7), 365, true);
                                                                setCookie('__uid', loginData.message.body.customer_id, 365, true);
                                                                setCookie('__acAuth', loginData.ac_auth, 365, true);
                                                            }, 1);
                                                            document.location = window.theme.custom.links.pages.account_center;
                                                        } else { //middleware failure
                                                            if (loginData.hasOwnProperty("message") && loginData.message.hasOwnProperty("body") && loginData.message.body.hasOwnProperty("message")) {
                                                                errorNotify("Heroku - EGO Commercial Failed to login after user/create 1: " + loginData.message.body.message);
                                                            } else {
                                                                errorNotify("Heroku - EGO Commercial Failed to login after user/create 2: " + loginData);
                                                            }

                                                            loadingMask("hide");
                                                            createFormSubmitted = false;
                                                            alert(window.theme.custom.global.error.generic_error);
                                                            grecaptcha.reset();
                                                        }
                                                    })
                                                    .fail(function (error) {
                                                        if (error.responseJSON.success === true) { // proxy success
                                                            errorNotify("Heroku - EGO Commercial Failed to login after user/create: " + error.responseJSON.message.body.message);
                                                        } else { // proxy failure
                                                            errorNotify('Proxy - EGO Commercial Failed to login after user/create: ', error.responseJSON.message);
                                                        }

                                                        loadingMask("hide");
                                                        createFormSubmitted = false;
                                                        alert(window.theme.custom.global.error.generic_error);
                                                        grecaptcha.reset();
                                                    });
                                            }).catch(function (err) {
                                                alert(window.theme.custom.global.error.generic_error);
                                                errorNotify('EGO Commercial user/login - (account/create) Promise Catch: ' + err);
                                                grecaptcha.reset();
                                                logout();
                                            });
                                        } else {//middleware failure
                                            loadingMask("hide");
                                            grecaptcha.reset();

                                            if (createData.hasOwnProperty("message") && createData.message === "Bypass Complete") {
                                                alert("Welcome Email Test Successfully Sent.");
                                            } else if (createData.hasOwnProperty("message") && createData.message.hasOwnProperty("type") && createData.message.type === "email_validation") {
                                                if (createData.message.hasOwnProperty("status")) {
                                                    switch (createData.message.status) {
                                                        case 400:
                                                            alert(window.theme.custom.account_create_page.invalid_email.email_address + " " + $("#create_email").val() + " " + window.theme.custom.account_create_page.invalid_email.is_invalid + ".");
                                                            break;
                                                        default:
                                                            alert(window.theme.custom.global.error.generic_error);
                                                            break;
                                                    }
                                                }
                                            } else {
                                                if (createData.hasOwnProperty("message")) {
                                                    if (createData.message.hasOwnProperty("type") && createData.message.type === "recaptcha") { //google recaptcha error
                                                        alert(window.theme.custom.global.error.generic_error);
                                                        errorNotify('Proxy - EGO Commercial Account Creation Failure (Google reCAPTCHA Error - Score too low or other possible error): ', JSON.stringify(createData));
                                                    } else if (createData.message.hasOwnProperty("body") && createData.message.body.hasOwnProperty("status")) { //heroku error
                                                        switch (createData.message.body.status) {
                                                            case "409":
                                                                alert(window.theme.custom.account_create_page.error_code.four_zero_nine);
                                                                break;
                                                            case "422":
                                                                alert(window.theme.custom.account_create_page.error_code.four_twenty_two);
                                                                break;
                                                            default:
                                                                alert(window.theme.custom.global.error.generic_error)
                                                                errorNotify('Heroku - EGO Commercial Account Creation Error: ', createData.message.body.message);
                                                        }
                                                    } else {
                                                        alert(window.theme.custom.global.error.generic_error);
                                                        errorNotify('Proxy - EGO Commercial Account Creation Error 2: ', JSON.stringify(createData));
                                                    }
                                                } else {
                                                    alert(window.theme.custom.global.error.generic_error);
                                                    errorNotify('Proxy - EGO Commercial Account Creation Error 1: ', JSON.stringify(createData));
                                                }
                                            }

                                            createFormSubmitted = false;
                                        }
                                    })
                                    .fail(function (error) {
                                        loadingMask("hide");
                                        createFormSubmitted = false;

                                        alert(window.theme.custom.global.error.generic_error);
                                        errorNotify('Proxy - EGO Commercial Create Account Failure: ' + error.responseText);
                                        grecaptcha.reset();
                                    });

                            }).catch(function (err) {
                                alert(window.theme.custom.global.error.generic_error);
                                errorNotify('EGO Commercial user/create Promise Catch: ' + err);
                                grecaptcha.reset();
                                logout();
                            });
                        }
                    }
                }
            });
        }
    }

    /* User Account Center - Get User Details on Page Load */
    if (accountCenter.length) {
        let currentUser = {};
        loadingMask("show");

        getApiPath('user/details').then(function() {
            const userDetails = {
                user_info: {
                    event_type: "my_account_page_load",
                    store_id: "1"
                }
            }

            $.ajax({
                method: 'POST',
                url: apiURL + "rest/all/V1/chervon/proxy/account-processing/",
                data: JSON.stringify(userDetails),
                contentType: 'application/json',
                headers: {
                    "Authorization": "Bearer " + getCookie('__acAuth')
                }
            })
               .done(function (detailsData) {
                   detailsData = JSON.parse(detailsData);
                   const detailsDataBody = detailsData.message.body;

                   if (detailsData.success && detailsDataBody.statusCode === 200) {
                       currentUser = {
                           'email': detailsDataBody.email,
                           'firstName': detailsDataBody.firstName,
                           'lastName': detailsDataBody.lastName
                       };

                       localStorage.setItem('currentUser', JSON.stringify(currentUser));

                       window.accountUser = detailsDataBody;

                       $('.ego-acc-center__name').text(detailsDataBody.firstName + ' ' + detailsDataBody.lastName);
                       $('.ego-acc-center__email').text(detailsDataBody.email);
                       $(".ego-acc-center__company").text(detailsDataBody.organizationName ? detailsDataBody.organizationName : "N/A");
                       $('.ego-acc-center__address').text(
                          [
                              detailsDataBody.address1,
                              detailsDataBody.address2,
                              detailsDataBody.address3,
                              detailsDataBody.postcode,
                              detailsDataBody.country
                          ]
                             .filter(Boolean)
                             .join(', ') || 'N/A'
                       );
                       $("#update_first_name").val(detailsDataBody.firstName);
                       $("#update_last_name").val(detailsDataBody.lastName);
                       $("#update_email").val(detailsDataBody.email);
                       $("#update_company, #update_info_company").val(detailsDataBody.organizationName);
                       $("#update_address_1").val(detailsDataBody.address1);
                       $("#update_city").val(detailsDataBody.address2);
                       $("#update_state").val(detailsDataBody.address3).selectmenu("refresh");
                       $("#update_zip").val(detailsDataBody.postcode);
                       $("#update_country").val(detailsDataBody.country).selectmenu("refresh");
                       $("#update_phone").val(detailsDataBody.phone);
                       $("#update_opt_in").prop("checked", detailsDataBody.sendMarketingEmails);

                       $('#acc-center-select').on('selectmenuchange', function () {
                           let filterValue = $('#acc-center-select').val();
                           $("#" + filterValue).click();
                       });

                       getCustomerWarrantyData("hs_backfill", detailsDataBody);

                       if (!detailsDataBody.hasOwnProperty("organizationName") || detailsDataBody.organizationName === "") {
                           $("#company-modal").modal({
                               clickClose: false
                           });
                       } else {
                           // $("#company-modal").modal();
                       }
                   } else {
                       errorNotify("Error: Cannot load user details: my_account_page_load else: ", detailsData);
                       alert(window.theme.custom.global.error.fetch_data);
                       logout();
                   }
               })
               .fail(function (error) {
                   errorNotify("Error: Cannot load user details: my_account_page_load fail: ", error);
                   alert(window.theme.custom.global.error.fetch_data);
                   logout();
               });
        }).catch(function (err) {
            alert(window.theme.custom.global.error.fetch_data);
            errorNotify("Error: Cannot load user details: my_account_page_load catch: ", err);
            logout();
        });

        $("#company_update").validate({
            errorClass: 'ego-invalid',
            validClass: 'ego-valid',
            errorElement: 'span',
            errorPlacement: function (error, element) {
                error.addClass('ego-error-show');
                element.parent().append(error);
            },
            submitHandler: function (form) {
                loadingMask("show");
                getApiPath('user/update').then(function (apiPath) {
                    let company = $("#update_company").val();

                    let formData = {
                        brand_name: 'EGO',
                        organization_name: company,
                        user_info: {
                            auth: "Bearer " + getCookie('__auth'),
                            brand_name: 'EGOC',
                            company: company,
                            email_address: currentUser ? currentUser.email : "",
                            hs_language: Shopify.locale,
                            hs_first_name: hsFirstName,
                            hs_last_name: hsLastName,
                            method: "PATCH",
                            event_type: "company_update",
                            url: apiPath,
                            hs_id: hsId,
                            store_id: "1", //defaulting to EGO US
                            store_locale: Shopify.locale
                        }
                    }

                    $.ajax({
                        method: 'POST',
                        url: apiURL + "rest/all/V1/chervon/proxy/account-processing/",
                        data: JSON.stringify(formData),
                        contentType: 'application/json',
                    })
                        .done(function (data) {
                            $(".ego-c-companyform").closest(".ego-c-form").find(".ego-c-form-initial").fadeOut(function () {
                                $(".ego-c-companyform").closest(".ego-c-form").find(".ego-c-form-success").fadeIn();
                            });
                            $(".ego-acc-center__company").text(company);
                            $("#update_info_company").val(company)
                            loadingMask("hide");
                            setTimeout(function () {
                                $.modal.close();
                            }, 2500);
                        })
                        .fail(function (error) {
                            errorNotify('Proxy - Ego Commercial Cannot Update User Company Info: ' + error.responseText);
                            alert(window.theme.custom.global.error.fetch_data);
                            logout();
                        });
                });
            }
        });

        $("#customer_update").validate({
            errorClass: 'ego-invalid',
            validClass: 'ego-valid',
            errorElement: 'span',
            errorPlacement: function (error, element) {
                error.addClass('ego-error-show');
                element.parent().append(error);
            },
            rules: {
                "customer[first_name]": {
                    lettersOnly: true,
                    preventonlywhitespace: true,
                    required: true
                }, "customer[last_name]": {
                    lettersOnly: true,
                    preventonlywhitespace: true,
                    required: true
                }, "customer[email]": {
                    customemailvalidation: true,
                    required: true
                }, "customer[phone]": {
                    digits: true
                }
            },
            messages: {
                "customer[first_name]": {
                    required: window.theme.custom.global.error.required
                }, "customer[last_name]": {
                    required: window.theme.custom.global.error.required
                }, "customer[email]": {
                    required: window.theme.custom.global.error.email
                }, "customer[phone]": {
                    minlength: window.theme.custom.global.error.password_min_length,
                    digits: window.theme.custom.global.error.please_enter_only_digits
                }
            },
            submitHandler: function (form) {
                loadingMask("show");
                getApiPath('user/update').then(function (apiPath) {
                    let customer_update_first_name = titleCase($('#update_first_name').val());
                    let customer_update_last_name = titleCase($('#update_last_name').val());
                    let customer_update_email_address = $('#update_email').val().toLowerCase();
                    let customer_update_address_1 = $("#update_address_1").val();
                    let customer_update_address_2 = $("#update_city").val();
                    let customer_update_address_3 = $("#update_state").val();
                    let customer_update_postcode = $("#update_zip").val();
                    let customer_update_country = $("#update_country").val();
                    let customer_update_company = $('#update_info_company').val();
                    let customer_update_mobile_phone = $('#update_phone').val();
                    let customer_update_marketing_opt_in = $('#update_opt_in').is(':checked');

                    let formData = {
                        brand_name: 'EGO',
                        first_name: customer_update_first_name,
                        last_name: customer_update_last_name,
                        email_address: customer_update_email_address,
                        address_1: customer_update_address_1,
                        address_2: customer_update_address_2,
                        address_3: customer_update_address_3,
                        postcode: customer_update_postcode,
                        country: customer_update_country,
                        organization_name: customer_update_company,
                        mobile_phone: customer_update_mobile_phone,
                        marketing_opt_in: customer_update_marketing_opt_in,
                        user_info: {
                            auth: "Bearer " + getCookie('__auth'),
                            brand_name: 'EGOC',
                            first_name: customer_update_first_name,
                            last_name: customer_update_last_name,
                            email_address: customer_update_email_address,
                            email_address_original: currentUser.email,
                            address_1: customer_update_address_1,
                            address_2: customer_update_address_2,
                            address_3: customer_update_address_3,
                            postcode: customer_update_postcode,
                            country: customer_update_country,
                            company: customer_update_company,
                            mobile_phone: customer_update_mobile_phone,
                            marketing_opt_in: customer_update_marketing_opt_in,
                            hs_language: Shopify.locale,
                            hs_first_name: hsFirstName,
                            hs_last_name: hsLastName,
                            method: "PATCH",
                            event_type: "customer_update",
                            url: apiPath,
                            hs_id: hsId,
                            store_id: "1", //defaulting to EGO US
                            store_locale: Shopify.locale
                        }
                    }

                    $.ajax({
                        method: 'POST',
                        url: apiURL + "rest/all/V1/chervon/proxy/account-processing/",
                        data: JSON.stringify(formData),
                        contentType: 'application/json',
                    })
                        .done(function (data) {
                            let updateData = JSON.parse(data);
                            // proxy success
                            if (updateData.success) {//middleware success
                                $(".ego-c-form-customer-update-form").closest(".ego-c-form").find(".ego-c-form-initial").fadeOut(function () {
                                    $(".ego-c-form-customer-update-form").closest(".ego-c-form").find(".ego-c-form-success").fadeIn();
                                });
                                $(".ego-acc-center__name").text(customer_update_first_name + " " + customer_update_last_name);
                                $(".ego-acc-center__email").text(customer_update_email_address);
                                $(".ego-acc-center__company").text(customer_update_company);
                                $('.ego-acc-center__address').text(customer_update_address_1 ? customer_update_address_1 + " " + customer_update_address_2 + " " + customer_update_address_3 + ", " + customer_update_postcode + ", " + customer_update_country : "N/A");

                                // update local storage currentUser
                                loadingMask("hide");
                                currentUser = {
                                    'email': customer_update_email_address,
                                    'firstName': customer_update_first_name,
                                    'lastName': customer_update_last_name
                                }

                                localStorage.setItem('currentUser', JSON.stringify(currentUser));

                                // update hubspot cookies / variables
                                setCookie('__hsFirstName', customer_update_first_name, 365, true);
                                setCookie('__hsLastName', customer_update_last_name, 365, true);
                                hsFirstName = customer_update_first_name;
                                hsLastName = customer_update_last_name;

                                setTimeout(function () {
                                    $.modal.close();
                                    setTimeout(function () {
                                        $(".ego-c-form-customer-update-form").closest(".ego-c-form").find(".ego-c-form-success").fadeOut(function () {
                                            $(".ego-c-form-customer-update-form").closest(".ego-c-form").find(".ego-c-form-initial").fadeIn();
                                        });
                                    }, 1000);
                                }, 2500);
                            } else {
                                if (updateData.hasOwnProperty("message") && updateData.message.hasOwnProperty("header") && updateData.message.header.hasOwnProperty("status")) { //heroku error
                                    switch (updateData.message.header.message) {
                                        case "An Error Has Occurred. This customer's phone number already exists.":
                                            alert(window.theme.custom.account_create_page.error_code.four_zero_nine);
                                            break;
                                        case "This email has already been registered, please log in directly or reset the password.":
                                            alert(window.theme.custom.account_create_page.error_code.four_twenty_two);
                                            break;
                                        default:
                                            alert(window.theme.custom.global.error.generic_error)
                                            errorNotify('Heroku - EGO Commercial Account Creation Error: ', createData.message.body.message);
                                    }

                                    loadingMask("hide");
                                }
                            }
                        })
                        .fail(function (error) {
                            errorNotify('Proxy - Ego Commercial Cannot Update User Info: ' + error.responseText);
                            alert(window.theme.custom.global.error.fetch_data);
                            logout();
                        });
                });
            }
        });

        /****************************/
        /* Subscription Type Update */
        /****************************/
        $("#subscription_type_toggle_all").click(function () {
            $('.ego-c-subscription-type-update-form__col .ego-c-checkbox input').prop('checked', this.checked);
        });

        /**************************************************/
        /* Loads modal and fetches subscription type data */
        /**************************************************/
        $('a[data-modal]').click(function(event) {
            loadingMask("show");
            let _this = $(this);

            getApiPath('user/details').then(function () {
                const userDetails = {
                    user_info: {
                        event_type: "subscription_modal_load",
                        store_id: "1"
                    }
                }

                $.ajax({
                    method: 'POST',
                    url: apiURL + "rest/all/V1/chervon/proxy/account-processing/",
                    data: JSON.stringify(userDetails),
                    contentType: 'application/json',
                    headers: {
                        "Authorization": "Bearer " + getCookie('__acAuth')
                    },
                })
                    .done(function (detailsData) {
                        detailsData = JSON.parse(detailsData);
                        const detailsDataBody = detailsData.message.body;

                        if (detailsData.success && detailsDataBody.statusCode === 200) {
                            let currentUser = {
                                'email': detailsDataBody.email,
                                'firstName': detailsDataBody.firstName,
                                'lastName': detailsDataBody.lastName
                            };

                            localStorage.setItem('currentUser', JSON.stringify(currentUser));

                            /***************************/
                            /* Get Subscription Status */
                            /***************************/
                            let subscriptionResultsArray = {
                                "email": detailsDataBody.email,
                                "type": "get_subscription_status",
                                "businessUnitId": "1484306"
                            }

                            $.ajax({
                                method: 'POST',
                                url: apiURL + "rest/all/V1/chervon/proxy/subscription-type/1",
                                data: JSON.stringify(subscriptionResultsArray),
                                contentType: 'application/json'
                            })
                               .done(function (detailsData) {
                                   detailsData = JSON.parse(detailsData);

                                   // proxy success
                                   if (detailsData.success) {
                                       if (detailsData.hasOwnProperty("message") &&
                                          detailsData.message.hasOwnProperty("body") &&
                                          detailsData.message.body.hasOwnProperty("results")) {
                                           let subscriptionCol = $(".ego-c-subscription-type-update-form__col");
                                           subscriptionCol.html("");
                                           let subscriptionResults = detailsData.message.body.results;

                                           $(subscriptionResults).each(function (i, obj) {
                                               let subscriptionSimpleName = "";
                                               let subscriptionId = "";
                                               let subscribeStatus = "";

                                               if (obj.hasOwnProperty("subscriptionName")) {
                                                   subscriptionId = obj.subscriptionId;
                                                   subscribeStatus = obj.status;
                                               } else if (obj.hasOwnProperty("name")) {
                                                   subscriptionId = obj.id;
                                               }

                                               switch (parseInt(subscriptionId)) {
                                                   case 302036872:
                                                       subscriptionSimpleName = window.theme.custom.account_center.update_subscription_modal.commercial_product_interest;
                                                       break;
                                                   case 302032810:
                                                       subscriptionSimpleName = window.theme.custom.account_center.update_subscription_modal.marketing_information;
                                                       break;
                                               }

                                               subscribeStatus = subscribeStatus === "SUBSCRIBED" ? "checked" : "";

                                               subscriptionCol.append(
                                                  '<div>\n' +
                                                  '<label class="ego-c-checkbox ego-c-checkbox-white" for="' + subscriptionId + '">\n' +
                                                  subscriptionSimpleName +
                                                  '<input type="checkbox" id="' + subscriptionId + '" ' + subscribeStatus + '>\n' +
                                                  '<span class="checkmark"></span>\n' +
                                                  '</label>\n' +
                                                  '</div>'
                                               )
                                           });
                                       }

                                       _this.modal({clickClose: false});
                                   } else {
                                       if (detailsData.hasOwnProperty("message") &&
                                          detailsData.message.hasOwnProperty("body") &&
                                          detailsData.message.body.hasOwnProperty("status")) {
                                           errorNotify('Hubspot - Ego Commercial Cannot Get Subscription Types: ', detailsData.message.body.message);
                                       } else {
                                           errorNotify('Hubspot - Ego Commercial Cannot Get Subscription Types: ', detailsData);
                                       }

                                       alert(window.theme.custom.global.error.fetch_data);
                                   }
                               })
                               .fail(function (error) {
                                   errorNotify('Proxy - Ego Commercial Cannot Get Subscription Types: ' + error.responseText);
                                   alert(window.theme.custom.global.error.fetch_data);
                               });
                        } else {
                            errorNotify("Error: Cannot load user details: get_subscription_status else: ", detailsData);
                            alert(window.theme.custom.global.error.fetch_data);
                            logout();
                        }

                        loadingMask("hide");
                    })
                    .fail(function (error) {
                        errorNotify("Error: Cannot load user details: get_subscription_status fail: ", error);
                        alert(window.theme.custom.global.error.fetch_data);
                        logout();
                    });
            }).catch(function (err) {
                alert(window.theme.custom.global.error.fetch_data);
                errorNotify("Error: Cannot load user details: get_subscription_status catch: ", err);
                logout();
            });

            return false;
        });

        /************************************/
        /* Submits Subscription Type Update */
        /************************************/
        $("#customer_subscription_type_update").submit(function(e) {
            e.preventDefault();
            loadingMask("show");

            let subscriptionResultsArray = {
                "type": "update_subscription_status",
                "inputs": []
            }

            $(".ego-c-subscription-type-update-form__col input").each(function(i, obj) {
                let _obj = $(obj);

                subscriptionResultsArray.inputs.push({
                    "statusState": _obj.prop("checked") === true ? "SUBSCRIBED" : "UNSUBSCRIBED",
                    "channel": "EMAIL",
                    "subscriberIdString": currentUser.email,
                    "subscriptionId": _obj.attr("id")
                });
            });


            $.ajax({
                method: 'POST',
                url: apiURL + "rest/all/V1/chervon/proxy/subscription-type/1",
                data: JSON.stringify(subscriptionResultsArray),
                contentType: 'application/json'
            })
                .done(function (detailsData) {
                    detailsData = JSON.parse(detailsData);

                    // proxy success
                    if (detailsData.success) {
                        if (detailsData.hasOwnProperty("message") &&
                            detailsData.message.hasOwnProperty("status")) {
                            $(".ego-c-form-subscription-type-update-form").closest(".ego-c-form").find(".ego-c-form-initial").fadeOut(function () {
                                $(".ego-c-form-subscription-type-update-form").closest(".ego-c-form").find(".ego-c-form-success").fadeIn();
                            });
                        } else {
                            alert(window.theme.custom.global.error.fetch_data);
                            logout();
                        }
                    } else {
                        if (detailsData.hasOwnProperty("message") &&
                            detailsData.message.hasOwnProperty("body") &&
                            detailsData.message.body.hasOwnProperty("status")) {
                            errorNotify('Hubspot - Ego Commercial Cannot Update Subscription Types: ', detailsData.message.body.message);
                        } else {
                            errorNotify('Hubspot - Ego Commercial Cannot Update Subscription Types: ', detailsData);
                        }

                        alert(window.theme.custom.global.error.fetch_data);
                        logout();
                    }

                    loadingMask("hide");
                    setTimeout(function () {
                        $.modal.close();

                        setTimeout(function () {
                            $(".ego-c-form-subscription-type-update-form").closest(".ego-c-form").find(".ego-c-form-success").hide();
                            $(".ego-c-form-subscription-type-update-form").closest(".ego-c-form").find(".ego-c-form-initial").show();
                        }, 1000);
                    }, 2500);
                })
                .fail(function (error) {
                    errorNotify('Proxy - Ego Commercial Cannot Update Subscription Types: ' + error.responseText);
                    alert(window.theme.custom.global.error.fetch_data);
                    logout();
                });
        });

        function getCustomerWarrantyData(_eventType) {
            getApiPath('warranty?customer_id=' + getCookie('__uid') + "&brand_name=EGO").then(function (apiPath) {
                let formDataTools = {
                    user_info: {
                        auth: "Bearer " + getCookie('__auth'),
                        brand_name: 'EGOC',
                        email_address: currentUser ? currentUser.email : "",
                        hs_language: Shopify.locale,
                        method: "GET",
                        event_type: _eventType,
                        url: apiPath,
                        hs_id: hsId,
                        hs_first_name: hsFirstName,
                        hs_last_name: hsLastName,
                        store_id: "1", //defaulting to EGO US
                        store_locale: Shopify.locale
                    }
                }

                // we only want to send this event once
                if (sessionStorage.getItem("hs_name_update_event_sent") !== "true") {
                    formDataTools.user_info.first_name = currentUser ? currentUser.first_name : "";
                    formDataTools.user_info.last_name = currentUser ? currentUser.last_name : "";
                    sessionStorage.setItem("hs_name_update_event_sent", "true");
                }

                $.ajax({
                    method: 'POST',
                    url: apiURL + "rest/all/V1/chervon/proxy/account-processing/",
                    data: JSON.stringify(formDataTools), contentType: 'application/json'
                })
                    .done(function (detailsData) {
                        detailsData = JSON.parse(detailsData);
                        // proxy success
                        if (detailsData.success) {//middleware success
                            if (_eventType === "my tools") {
                                $("#info-my-tools div.ego-acc-center-table__wr table tbody").html('');
                                detailsData.message.body.warranties.forEach(function (obj) {
                                    if (obj['warranty items'].length > 0) {
                                        let master_product = getObj("sku", obj.master_model_number);
                                        let master_product_name = master_product ? master_product.name : obj.master_product_name;
                                        let purchase_date = obj.purchase_date ? `${obj.purchase_date.substring(0, 2)} / ${obj.purchase_date.substring(2, 4)} / ${obj.purchase_date.substring(4, 6)}` : 'N/A';
                                        let placeOfPurchase = obj.place_of_purchase;
                                        placeOfPurchase = placeOfPurchase ? placeOfPurchase.replace('_', ' ') : 'N/A'
                                        placeOfPurchase === "Lowes" ? placeOfPurchase = "Lowe's" : placeOfPurchase;

                                        let html = `<tr>
                                      <td data-title="Model No.">
                                          <div>
                                              <span class="">
                                                  ${obj.master_model_number ? obj.master_model_number : "N/A"}
                                              </span>
                                          </div>
                                      </td>`;

                                        let use = "";
                                        switch (obj.product_use_type) {
                                            case "Industrial/Professional/Commercial":
                                            case "Industrial/Commercial":
                                            case "Industrial/Professional":
                                            case "Professional/Commercial":
                                            case "Commercial":
                                                use = window.theme.custom.account_center.product_use_type.commercial;
                                                break;
                                            case "Residential":
                                                use = window.theme.custom.account_center.product_use_type.residential;
                                                break;
                                            default:
                                                use = "N/A";
                                        }

                                        html += `<td data-title="Use">
                                  <div>
                                      <span class="">
                                          ${use}
                                      </span>
                                  </div>
                              </td>`;
                                        html += `<td data-title="Serial Numbers">
                                  <div>
                                      <span class="">
                                          ${master_product_name}
                                      </span>
                                      <div class="ego-acc-center-table__special-data">`;
                                        obj['warranty items'].forEach(function (item) {
                                            let type = "";
                                            switch (item.product_type) {
                                                case "Product":
                                                    type = window.theme.custom.account_center.product_type.product
                                                    break;
                                                case "Battery":
                                                    type = window.theme.custom.account_center.product_type.battery
                                                    break;
                                                case "Charger":
                                                    type = window.theme.custom.account_center.product_type.charger
                                                    break;
                                                default:
                                                    type = "N/A";
                                            }

                                            if (item['serial_number']) {
                                                html += `<div class="ego-acc-center-table__special-wr">
                                              <span>
                                                   ${type}:
                                              </span>
                                              <span>
                                                  ${item.serial_number ? item.serial_number : "N/A"}
                                              </span>
                                          </div>`;
                                            }
                                        });

                                        html += `</div>
                                      </div>
                                  </td>
                                  <td data-title="Purchase date">
                                      <div>
                                          <span class="">${purchase_date}</span>
                                      </div>
                                  </td>
                                  <td data-title="Place">
                                      <div>
                                          <span class="">${placeOfPurchase}</span>
                                      </div>
                                  </td>
                              </tr>`;

                                        $("#info-my-tools div.ego-acc-center-table__wr table tbody").append(html);
                                    }
                                });
                                $(".ego-acc-cente-tablist > li").hide();
                                $("#info-my-tools").show();
                            } else if (_eventType === "hs_backfill") {
                                let _hsq = window._hsq = window._hsq || [];

                                _hsq.push(["identify", {
                                    email: currentUser.email_address
                                }]);
                                _hsq.push(['trackPageView']);

                                if (detailsData.hasOwnProperty("hubspotResponse") && detailsData.hubspotResponse.hasOwnProperty("body") && detailsData.hubspotResponse.body.hasOwnProperty("results") && detailsData.hubspotResponse.body.results.length > 0) {
                                    let hubspotData = detailsData.hubspotResponse.body.results[0];

                                    setCookie('__hsID', hubspotData.id, 365, true);

                                    if (hubspotData.properties.firstname) {
                                        setCookie('__hsFirstName', hubspotData.properties.firstname, 365, true);
                                    } else {
                                        setCookie('__hsFirstName', currentUser ? currentUser.first_name : "", 365, true);
                                    }

                                    if (hubspotData.properties.lastname) {
                                        setCookie('__hsLastName', hubspotData.properties.lastname, 365, true);
                                    } else {
                                        setCookie('__hsLastName', currentUser ? currentUser.last_name : "", 365, true);
                                    }
                                }
                            }
                        } else { //middleware failure
                            if (detailsData.hasOwnProperty("message") && detailsData.message.hasOwnProperty("body") && detailsData.message.body.hasOwnProperty("status") && detailsData.message.body.status !== "401") {
                                errorNotify('Heroku - Ego Commercial Cannot Load Customer Warranty Data: ', detailsData.message.body.message);
                            } else {
                                errorNotify('Heroku - Ego Commercial Cannot Load Customer Warranty Data: ', detailsData);
                            }

                            alert(window.theme.custom.global.error.fetch_data);
                            logout();
                        }

                        loadingMask("hide");
                    })
                    .fail(function (error) {
                        errorNotify('Proxy - Ego Commercial Cannot Load Customer Warranty Data: ' + error.responseText);
                        alert(window.theme.custom.global.error.fetch_data);
                        logout();
                    });
            }).catch(function (err) {
                alert(window.theme.custom.global.error.generic_error);
                errorNotify('Ego Commercial warranty?customer_id= Promise Catch: ' + err);
                logout();
            });
        }

        $("#acc-my-account").on('click', function (e) {
            e.preventDefault();
            activeButton($(this));
            $(".ego-acc-cente-tablist > li").hide();
            $("#info-my-account").show();
        });

        $("#acc-my-tools").on('click', function (e) {
            e.preventDefault();
            loadingMask("show");
            activeButton($(this));

            getCustomerWarrantyData("my tools");
        });

        $("#acc-orders").on('click', function (e) {
            e.preventDefault();
            activeButton($(this));
            loadingMask("show");

            getApiPath('order?customer_id=' + getCookie('__uid')).then(function (apiPath) {
                $.ajax({
                    method: 'GET',
                    url: apiPath,
                    headers: {
                        "Authorization": "Bearer " + getCookie('__auth')
                    },
                    contentType: 'application/json'
                })
                    .done(function (detailsData, detailsStatus, detailsXHR) {
                        $("#info-orders div.ego-acc-center-table__wr table tbody").html('');
                        detailsData.order_items.forEach(function (obj) {
                            $("#info-orders div.ego-acc-center-table__wr table tbody").append(`<tr>
                          <td data-title="Product">
                            <div>
                              <span class="">${obj.product_name}</span>
                          </td>
                          <td data-title="Serial No">
                            <div>
                              <span class="">${obj.serial_number ? obj.serial_number : "-"}</span>
                          </td>
                          <td data-title="Order Date">
                            <div>
                              <span class="">${obj.order_date}</span>
                          </td>
                          <td data-title="Status">
                            <div>
                              <span class="">${obj.status}</span>
                          </td>
                          <td data-title="Tracking no.">
                            <div>
                              <span class="">${obj.tracking_number ? obj.tracking_number : "-"}</span>
                          </td>
                        </tr>`);
                        });
                        $(".ego-acc-cente-tablist > li").hide();
                        $("#info-orders").show();
                        loadingMask("hide");
                    })
                    .fail(function (error) {
                        if (error.status !== 401) { //401 = __auth expired or corrupt, no need to send email
                            errorNotify('Error: Ego Commercial Cannot Load Order Information', error);
                        }
                        alert(window.theme.custom.global.error.fetch_data);
                        logout();
                    });
            }).catch(function (err) {
                alert(window.theme.custom.global.error.generic_error);
                errorNotify('Ego Commercial order?customer_id= Promise Catch: ' + err);
                logout();
            });
        });

        $("#acc-service").on('click', function (e) {
            e.preventDefault();
            activeButton($(this));
            loadingMask("show");
            $(".ego-acc-customer-service").addClass('active');
            $(".ego-acc-customer-service-request").removeClass('active');
            loadCases();
        });

        function loadCases() {
            getApiPath('case?customer_id=' + getCookie('__uid')).then(function (apiPath) {
                $.ajax({
                    method: 'GET',
                    url: apiPath,
                    data: "brand_name=EGO",
                    headers: {
                        "Authorization": "Bearer " + getCookie('__auth')
                    },
                    contentType: 'application/json'
                })
                    .done(function (detailsData) {
                        $("#info-service div.ego-acc-center-table__wr table tbody").html('');
                        detailsData.cases.forEach(function (obj) {

                            let acc_case_options_1 = "";
                            let acc_case_options_2 = obj.status === window.theme.custom.account_center.closed ? window.theme.custom.account_center.case_closed : "In Progress";
                            let case_type = "";
                            switch (obj.case_type) {
                                case "Warranty Registration":
                                    case_type = window.theme.custom.account_center.customer_service_form.Warranty_Registration;
                                    break;
                                case "Warranty Order":
                                    case_type = window.theme.custom.account_center.customer_service_form.Warranty_Order;
                                    break;
                                case "Non-warranty Order":
                                    case_type = window.theme.custom.account_center.customer_service_form.Non_warranty_Order;
                                    break;
                                case "Tech Support":
                                    case_type = window.theme.custom.account_center.customer_service_form.Tech_Support;
                                    break;
                                case "Suggestions/Idea":
                                    case_type = window.theme.custom.account_center.customer_service_form.Suggestions_Ideas;
                                    break;
                                case "New Tool/Part Request":
                                    case_type = window.theme.custom.account_center.customer_service_form.New_Tool_Part_Request;
                                    break;
                                case "Other":
                                    case_type = window.theme.custom.global.other;
                                    break;
                                default:
                                    case_type = "N/A";
                            }

                            $("#info-service div.ego-acc-center-table__wr table tbody").append(`<tr id="case_${obj.case_id}">
                <td data-title="Case No.">
                  <div>
                    <span class="acc_case_number">${obj.case_number}</span>
                  </div>
                </td>
                <td data-title="Issue">
                  <div>

                    <span class="acc_case_type">${case_type}</span>
                  </div>
                </td>
                <td data-title="Status">
                  <div>
                    <span class="acc_case_status">${obj.status}</span>
                  </div>
                </td>
                <td data-title="Options">
                  <div id="option_${obj.case_id}">
                    <span class="acc_case_options_2">${acc_case_options_2}</span>
                  </div>
                </td>
              </tr>`);

                            // if (obj.status !== "Closed") {
                            //     acc_case_options_1 = document.createElement("a");
                            //     acc_case_options_1.href = "#";
                            //     acc_case_options_1.setAttribute('data-case-id', obj.case_id);
                            //     acc_case_options_1.classList.add("acc_case_options_1", "text-button", "ego-acc-center-table__link", "js-acc-center-close");
                            //     acc_case_options_1.textContent = "Close Case";
                            //     acc_case_options_1.onclick = function (e) {
                            //         e.preventDefault();
                            //         $(".ego-active-case").removeClass("ego-active-case");
                            //         acc_case_options_1.classList.add("ego-active-case");
                            //         $('body').addClass('no-scroll');
                            //         $("#js-acc-service-modal").modal();
                            //
                            //         $('.js-acc-service-close-case').on('click', function (e) {
                            //             closeAccServiceModal(e);
                            //             let currentCase = $(".ego-active-case").attr('data-case-id');
                            //
                            //             getApiPath('case/close?case_id=' + currentCase).then(function (apiPath) {
                            //                 $.ajax({
                            //                     method: 'PATCH',
                            //                     url: apiPath,
                            //                     data: "brand_name=EGO",
                            //                     headers: {
                            //                         "Authorization": "Bearer " + getCookie('__auth')
                            //                     },
                            //                     contentType: 'application/json',
                            //                     dataType: "text",
                            //                 })
                            //                     .done(function (detailsData) {
                            //                         $(`#case_${currentCase} .acc_case_options_1`).remove();
                            //                         $(`#case_${currentCase} .acc_case_options_2`).text(window.theme.custom.account_center.case_closed);
                            //                         loadingMask("hide");
                            //                     })
                            //                     .fail(function (error) {
                            //                         errorNotify('Error: Ego Commercial Closing Case', error);
                            //                         loadingMask("hide");
                            //                     });
                            //             }).catch(function (err) {
                            //                 alert("Please try again at a later time.");
                            //                 errorNotify('Ego Commercial Case Close Catch: ' + err);
                            //                 logout();
                            //             });
                            //         });
                            //     };
                            //     document.getElementById(`option_${obj.case_id}`).appendChild(acc_case_options_1);
                            // }
                        });
                        $(".ego-acc-cente-tablist > li").hide();
                        $("#info-service").show();
                        loadingMask("hide");
                    })
                    .fail(function (error) {
                        if (error.status !== 401) { //401 = __auth expired or corrupt, no need to send email
                            errorNotify('Error: Loading Cases', error);
                        }
                        alert(window.theme.custom.global.error.fetch_data);
                        logout();
                    });
            }).catch(function (err) {
                alert(window.theme.custom.global.error.generic_error);
                errorNotify('Ego Commercial case?customer_id= Promise Catch: ' + err);
                logout();
            });
        }

        function closeAccServiceModal(e) {
            e.preventDefault();
            $.modal.close();
        }

        $('.js-acc-service-cancel').on('click', function (e) {
            closeAccServiceModal(e);
        });

        $("#customer-service-form").validate({
            errorClass: 'ego-invalid',
            validClass: 'ego-valid',
            errorElement: 'span',
            ignore: [],
            errorPlacement: function (error, element) {
                error.addClass('ego-error-show');
                element.parent().append(error);
            },
            rules: {
                "acc-service-email": {
                    customemailvalidation: true
                },
                "acc-service-contact-num": {
                    required: true,
                    number: true
                }
            },
            messages: {
                'service-option': window.theme.custom.global.error.required,
                'acc-service-name': window.theme.custom.global.error.required,
                'acc-service-email': window.theme.custom.global.error.email,
                'acc-service-contact-num': window.theme.custom.global.error.required,
                'acc-service-message': window.theme.custom.global.error.required
            },
            submitHandler: function (form) {
                getApiPath('case/create').then(function (apiPath) {
                    var formData = {
                        customer_id: getCookie('__uid'),
                        description: form[5].value,
                        attachment_URL: form[1].value,
                        phone_number: form[4].value,
                        case_type: form[0].value,
                        brand_name: "EGO"
                    };

                    $.ajax({
                        method: 'POST',
                        url: apiPath,
                        data: JSON.stringify(formData),
                        headers: {
                            "Authorization": "Bearer " + getCookie('__auth')
                        },
                        contentType: 'application/json',
                        dataType: "text"
                    })
                        .done(function (data) {
                            $('.ego-acc-customer-service').addClass('active');
                            $('.ego-acc-customer-service-request').removeClass('active');
                            let caseForm = document.getElementById('customer-service-form');
                            caseForm.reset();
                            caseForm[2].value = accountUser.firstName + ' ' + accountUser.lastName;
                            caseForm[3].value = accountUser.email;
                            loadCases();
                            loadingMask("hide");
                        })
                        .fail(function (error) {
                            errorNotify('Error: EGO Commercial Creating Case', error);
                            loadingMask("hide");
                        });

                }).catch(function (err) {
                    alert(window.theme.custom.global.error.generic_error);
                    errorNotify('Ego Commercial case/create Promise Catch: ' + err);
                    logout();
                });

                return false;
            }
        });

        $('.js-service-select').on('selectmenuchange', function (e) {
            $("#customer-service-form").validate().element(this);
        });

        $("#acc-logout").click(function (e) {
            e.preventDefault();
            logout();
        });

        function activeButton(e) {
            $("#acc-center-menu > li > a").removeClass("active");
            $(e).addClass("active");
        }

        $(".js-acc-get-help").click(function (e) {
            e.preventDefault();
            $('.ego-acc-customer-service').removeClass('active');
            $('.ego-acc-customer-service-request').addClass('active');
        });
    }

    /************************/
    /* Product Registration */
    /************************/
    if (registration.length) {
        let _allowRegistrationStepTracking = true;
        let registrationData = [];
        let _registrationstep1Id = "";
        let _registrationstep2Id = "";
        let _registrationstep2SKU = "";
        let batteryRegistrationSku;
        let chargerRegistrationSku;
        let multipleBatteriesToRegister = false;
        let multipleChargersToRegister = false;

        /*****************************************************************/
        /* Check that account center is enabled on load of register page */
        /*****************************************************************/
        getApiPath('user/details').then(function (apiPath) {
            loadingMask("show");

            const userDetails = {
                user_info: {
                    event_type: "product_registration_page_load",
                    store_id: "1"
                }
            }

            $.ajax({
                method: 'POST',
                url: apiURL + "rest/all/V1/chervon/proxy/account-processing/",
                data: JSON.stringify(userDetails),
                contentType: 'application/json',
                headers: {
                    "Authorization": "Bearer " + getCookie('__acAuth')
                },
            })
                .done(function (detailsData) {
                    loadingMask("hide");
                    detailsData = JSON.parse(detailsData);
                    const detailsDataBody = detailsData.message.body;

                    if (detailsData.success && detailsDataBody.statusCode === 200) {
                        let currentUser = {
                            'email': detailsDataBody.email,
                            'firstName': detailsDataBody.firstName,
                            'lastName': detailsDataBody.lastName
                        }

                        localStorage.setItem('currentUser', JSON.stringify(currentUser));
                        clearQRCookies();
                        processQRAutoProcess();
                    } else {
                        errorNotify("Error: Cannot load user details: product_registration_page_load else: ", detailsData);
                        alert(window.theme.custom.global.error.generic_error);
                        logout();
                    }
                })
               .fail(function (error) {
                   errorNotify("Error: Cannot load user details: product_registration_page_load fail: ", error);
                   alert(window.theme.custom.global.error.generic_error);
                   logout();
               });
        }).catch(function(err) {
            alert(window.theme.custom.global.error.generic_error);
            errorNotify("Error: Cannot load user details: product_registration_page_load catch: ", err);
            logout();
        });

        /************************/
        /* Product Registration */
        /************************/
        $(document).on('click', '.js-register-product', function (e) {
            let currentInput = $(this).closest(".ego-c-register__prod-col").find('input');
            let currentActive = $('.js-register-step.active');
            $('.js-register-product').removeClass('active');
            currentInput.prop('checked', true);
            setActiveCheckbox();
            currentActive.find('.checkmark').removeClass('error');
            if ($(this).hasClass('active')) {
                $('html,body').scrollTop($(this).closest('.ego-c-register-step').find('.js-register-buttons').offset().top - ($(window).height() / 2));
            }
        });

        function setActiveCheckbox() {
            $('.js-register-product input:checked')
                .closest('.js-register-product')
                .addClass("active");
        }

        setActiveCheckbox();

        $('.ego-c-selectmenu').selectmenu({
            classes: {
                "ui-selectmenu-menu": "ego-c-purchase-ui-select-menu"
            },
            change: function () {
                let _this = $(this);

                if (_this.hasClass("js-purchase-receipt") || _this.hasClass("js-purchase-place") || _this.hasClass("js-purchase-use")) {
                    $("#purchase-form").validate().element(this);
                    $(this).next(".ui-selectmenu-button").removeClass('ego-invalid');
                    $(this).next(".ui-selectmenu-button").addClass('ego-valid');
                }
            }
        });

        function registerProdGoNext(e) {
            let current = this;
            if (e) {
                e.preventDefault();
                current = e.target;
            }
            let currentActive = $('.js-register-step.active'),
                currentActiveIndex = $('.js-register-step.active').index() + 1,
                stepsLength = $('.js-register-step').length,
                valid = currentActive.find('input:checked').length,
                headerHeight = $('.header').outerHeight();

            if (!$(current).closest('.ego-c-register').find('.js-register-radio').length) {
                valid = true
            }

            if (valid) {
                if (currentActiveIndex < stepsLength) {
                    $('.js-register-step').removeClass('active');
                    currentActive.next().addClass('active');
                    $('.js-register-back').addClass('active');
                    $('html,body').scrollTop($(".header").is(":visible") ? $('.ego-c-register-steps-wr').offset().top - headerHeight : $('.ego-c-register-steps-wr').offset().top);
                }
            } else {
                currentActive.find('.checkmark').addClass('error');
            }
        }

        function createStep(obj) {
            window.step3 = obj;
        }

        function step2SkuList(_data) {
            let skuList = _data.sku;

            $.each(_data.crosssell, function (index, csData) {
                if (csData.registration_data_use_only !== "1" && csData.hide_crosssell_from_pdp !== "1" ||
                    csData.register_only_products === "1" ||
                    (csData.registration_data_use_only !== "1" && csData.visibility !== "Not Visible Individually")) {
                    skuList = skuList + "," + csData.sku;
                }
            });

            skuList = skuList.split(',').sort().join(',<br>');

            return skuList;
        }

        $('.js-register-next-step1').on('click', function (e) {
            e.preventDefault();
            let regStep1Id = $(".ego-c-register-step1 .js-register-product.active").attr("id");
            let step2Template = $('.ego-c-register-step2-template').html();
            let step2SkusAdded = [];

            if (regStep1Id) {
                createStep();
                $.each(EGO_REGISTER_DATA, function (index, categoryData) {
                    if (categoryData.id === regStep1Id) {
                        $('.ego-c-register-step2-data').html('');
                        registrationData = categoryData;
                        if (registrationData.products.length) {
                            $.each(registrationData.products, function (index, pData) {
                                if (pData.registration_data_use_only !== "Yes") {
                                    // if (pData.register_only_products === "1" || (pData.registration_data_use_only !== "1" && pData.visibility !== "Not Visible Individually")) {
                                    let registeredProduct = step2Template;
                                    let skuList = step2SkuList(pData);

                                    // some tools are set to catalog,search and also crosssells of each other, resulting in duplicates in step 2. This will prevent those duplicates from being added.
                                    let duplicateTools = false;

                                    $(step2SkusAdded).each(function (i, obj) {
                                        if (obj === skuList) {
                                            duplicateTools = true;
                                            return false;
                                        }
                                    });

                                    step2SkusAdded.push(skuList);

                                    if (!duplicateTools) {
                                        registeredProduct = registeredProduct.replace(/{name}/g, pData.name);
                                        registeredProduct = registeredProduct.replace(/{skulist}/g, skuList);
                                        registeredProduct = registeredProduct.replace(/{sku}/g, skuList.replaceAll("<br>", ""));
                                        registeredProduct = registeredProduct.replace(/{id}/g, pData.id);
                                        registeredProduct = registeredProduct.replace(/{alt}/g, pData.name);
                                        registeredProduct = registeredProduct.replace(/{image}/g, pData.image);
                                        $('.ego-c-register-step2-data').append(registeredProduct);
                                    }
                                    // }
                                }
                            });
                        } else {
                            $.each(registrationData.subcategories, function (index, subCatData) {
                                $.each(subCatData.products, function (index, pData) {
                                    if (pData.registration_data_use_only !== "Yes") {
                                        // if (pData.register_only_products === "1" || (pData.registration_data_use_only !== "1" && pData.visibility !== "Not Visible Individually")) {
                                        let registeredProduct = step2Template;
                                        let skuList = step2SkuList(pData);

                                        registeredProduct = registeredProduct.replace(/{name}/g, pData.name);
                                        registeredProduct = registeredProduct.replace(/{skulist}/g, skuList.sort());
                                        registeredProduct = registeredProduct.replace(/{sku}/g, skuList.replaceAll("<br>", ""));
                                        registeredProduct = registeredProduct.replace(/{id}/g, pData.id);
                                        registeredProduct = registeredProduct.replace(/{alt}/g, pData.name);
                                        registeredProduct = registeredProduct.replace(/{image}/g, pData.image);
                                        $('.ego-c-register-step2-data').append(registeredProduct);
                                        // }
                                    }
                                });
                            });
                        }
                    }
                });
            } else {
                $(".js-register-radio").prop('checked', false);
            }

            registerProdGoNext(e);
            addGtmTracking("registration_step", 1);
        });

        $('.js-register-next-step2').on('click', function (e) {
            e.preventDefault();
            $(".charger_info").hide();
            $(".battery_serial_input, .charger_serial_input").removeClass("required").val("");
            let regStep2Id = $(".ego-c-register-step2 .js-register-product.active").attr("id");

            if (regStep2Id) {
                $(".ego-c-register-step3-data, .ego-c-register-step3-battery-data, .product-serial-data").html("");
                let products = [];
                let batteries = [];
                let chargers = [];
                let master_product = getObj('id', regStep2Id);
                let bundleBatteryRegisterAll = master_product.bundle_battery_register_all;
                $(".ego-c-register-ew").hide();
                $(".js-register-ew-checkbox-opt-in").prop('checked', false).trigger("change");
                $('.js-purchase-use').val(""); // your default option's value
                $('.js-purchase-use').selectmenu("refresh");

                createStep(master_product);

                if (master_product.bundle_sku) {
                    master_product.bundle_sku.replaceAll(', ', ',').split(',').forEach(function (product) {
                        let productObj = getObj('sku', product);

                        products.push(productObj);
                    });

                    if (master_product.bundle_battery) {
                        master_product.bundle_battery.replaceAll(', ', ',').split(',').forEach(function (battery) {
                            let batteryObj = getObj('sku', battery);
                            batteries.push(batteryObj);
                        });
                    }

                    if (master_product.bundle_charger) {
                        master_product.bundle_charger.replaceAll(', ', ',').split(',').forEach(function (charger) {
                            chargers.push(getObj('sku', charger));
                        });
                    }
                } else {
                    products.push(master_product);
                }

                window.allProducts = {
                    products,
                    batteries,
                    chargers,
                    master_product
                }

                let masterImage = master_product.image;

                let product_template = `
              <div class="ego-c-register-item ego-c-register-item--single">
                  <div class="ego-c-register-item__img-wr">

                      <img src="${masterImage}" alt="${master_product.name}">
                  </div>
                  <div class="ego-c-register-item__input-wr">
                      <div class="ego-c-register-item__title-wr">
                          <h3>${master_product.name}</h3>
                          <p>${master_product.sku}</p>
                      </div>
                  </div>
              </div>`;
                $('.ego-c-register-step3-data').append(product_template);

                //fix for registration if the bare tool is not sold by itself but only sold in a kit.
                let kitOnly = false;
                if (products[0] === "null" || products[0] === null) {
                    kitOnly = true;
                    products = []
                    products.push(master_product);
                }

                products.forEach(function (product, index) {
                    let productSku = product.sku;

                    if (kitOnly) {
                        productSku = product.bundle_sku;
                    }

                    let serialNumberCopy = product.serial_number_location_image.indexOf("/no-image") === -1 ? window.theme.custom.product_registration.locate_sn : "";

                    let product_serial = `
                  <h3 class="product_serial_number">${window.theme.custom.product_registration.product_serial_number + " " + productSku}</h3>
                  <a href="#" class="ego-c-register-purchase__img-link js-purchase-modal-link ego-c-link">${serialNumberCopy}</a>
                  <div class="js-purchase-modal-content">
                      <img class="product_serial_image" src="${product.serial_number_location_image}" alt="${product.name}">
                  </div>
                  <div class="field">
                    <div>
                      <label for="serial-${product.serial_number_prefix}" class="ego-form-group__serial-number-prefix">${product.serial_number_prefix}</label>
                      <input type="text" class="ego-c-register-purchase__input product_serial_input full required serial-${productSku}" id="serial-${product.serial_number_prefix}" sku="${productSku}" serial="${product.serial_number_prefix}" name="product-serial-${index}" maxlength="11" minlength="9">
                      <img src="https://cdn.shopify.com/s/files/1/0689/6556/4654/files/icon-scan.svg?v=1725553364" alt="Scan Icon" class="ego-c-register-purchase__input-scan" data-sku="${productSku}" loading="lazy">
                  </div>
                  </div>`;
                    $(".product-serial-data").append(product_serial);
                });


                //Check If array values are exactly equal
                Array.prototype.allValuesSame = function () {
                    for (let i = 1; i < this.length; i++) {
                        if (this[i] !== this[0]) {
                            return false;
                        }
                    }
                    return true;
                }

                let sameBatterySku = batteries.allValuesSame();
                multipleBatteriesToRegister = false; //SET BACK TO FALSE IF THE USER LOADS ANOTHER TOOL

                // ADDS BATTERY RADIO BUTTON SELECTION IF THERE ARE 2 BATTERIES TO CHOOSE FROM
                if (batteries.length > 1 && !sameBatterySku && bundleBatteryRegisterAll !== "true") {
                    multipleBatteriesToRegister = true;
                    let bSku = "";

                    let battery_radio_template = `
              <h3 class="ego-title ego-title--small ego-c-register-radio">${window.theme.custom.product_registration.select_a_battery}</h3>
              <div class="btn-group btn-group-toggle ego-c-register-radio" id="ego-c-register-radio-container-battery" data-toggle="buttons">
              </div>`;
                    $(".product-serial-data").append(battery_radio_template);

                    batteries.forEach(function (battery, index) {
                        if (bSku !== battery.sku) {
                            $("#ego-c-register-radio-container-battery").append("<label class=\"btn btn-secondary ego-c-radio\">" + battery.sku + "<input type=\"radio\" name=\"batteryOptions\" id=\"battery-" + battery.sku + "\" autocomplete=\"off\"><span class=\"checkmark\"></span></label>");
                        }
                        bSku = battery.sku;
                    });
                }

                batteries.forEach(function (battery, index) {
                    let serialNumberCopyBattery = battery.serial_number_location_image.indexOf("/no-image") === -1 ? window.theme.custom.product_registration.locate_sn : "";

                    let battery_template =
                        `<div class="battery-form-container battery-${battery.sku}">
                      <h3 class="ego-title ego-title--small">${window.theme.custom.product_registration.battery_serial_number + " " + battery.sku}</h3>
                      <a href="#" class="ego-c-register-purchase__img-link js-purchase-modal-link ego-c-link">${serialNumberCopyBattery}</a>
                      <div class="js-purchase-modal-content">
                          <img src="${battery.serial_number_location_image}" alt="${battery.name}">
                      </div>
                      <div class="field">
                        <div>
                          <label for="serial-${battery.serial_number_prefix + index}" class="ego-form-group__serial-number-prefix">${battery.serial_number_prefix}</label>
                          <input type="text" class="ego-c-register-purchase__input full battery_serial_input required serial-${battery.sku}" id="serial-${battery.serial_number_prefix + index}" sku="${battery.sku}" serial="${battery.serial_number_prefix}" name="battery-serial-${index}" required maxlength="11" minlength="9">
                          <img src="https://cdn.shopify.com/s/files/1/0689/6556/4654/files/icon-scan.svg?v=1725553364" alt="Scan Icon" class="ego-c-register-purchase__input-scan" data-sku="${battery.sku}" loading="lazy">
                        </div>
                      </div>
                  </div>`;
                    $(".product-serial-data").append(battery_template);

                    batteryRegistrationSku = battery.sku;
                });

                if (batteries.length > 1 && !sameBatterySku && bundleBatteryRegisterAll !== "true") { //hide battery forms on load so user can pick with radio button
                    $('.battery-form-container').hide();
                    $('.battery-form-container').find('.battery_serial_input').removeClass('required').removeAttr('required');
                }

                // Hides/shows battery form clicked with radio button
                $("#ego-c-register-radio-container-battery .btn").click(function (e) {
                    $("#ego-c-register-radio-container-battery .btn").removeClass("active");
                    $(this).addClass("active");
                    let thisId = $(this).find('input').attr('id');
                    $('.battery-form-container').hide();
                    $('.battery-form-container').find('.battery_serial_input').removeClass('required').removeAttr('required');

                    if ($('.battery-form-container.' + thisId)[0]) {
                        $('.battery-form-container.' + thisId).show();
                        $('.battery-form-container.' + thisId).find('.battery_serial_input').addClass('required').attr('required');
                    }
                });

                let sameChargerSku = chargers.allValuesSame();
                multipleChargersToRegister = false; //SET BACK TO FALSE IF THE USER LOADS ANOTHER TOOL

                // ADDS CHARGER RADIO BUTTON SELECTION IF THERE ARE 2 CHARGERS TO CHOOSE FROM
                if (chargers.length > 1 && !sameChargerSku) {
                    multipleChargersToRegister = true;
                    let cSku = "";

                    let charger_radio_template = `
                          <h3 class="ego-title ego-title--small ego-c-register-radio">Select a charger</h3>
                          <div class="btn-group btn-group-toggle ego-c-register-radio" id="ego-c-register-radio-container-charger" data-toggle="buttons"></div>
                        `;

                    $(".product-serial-data").append(charger_radio_template);

                    chargers.forEach(function (charger, index) {
                        if (cSku !== charger.sku) {
                            $("#ego-c-register-radio-container-charger").append("<label class=\"btn btn-secondary ego-c-radio\">" + charger.sku + "<input type=\"radio\" name=\"chargerOptions\" id=\"charger-" + charger.sku + "\" autocomplete=\"off\"><span class=\"checkmark\"></span></label>");
                        }
                        cSku = charger.sku;
                    });
                }

                chargers.forEach(function (charger, index) {
                    let serialNumberCopyCharger = charger.serial_number_location_image.indexOf("/no-image") === -1 ? window.theme.custom.product_registration.locate_sn : "";

                    let charger_template = `
                            <div class="charger-form-container charger-${charger.sku}">
                                <h3 class="ego-title ego-title--small">${window.theme.custom.product_registration.charger_serial_number + " " + charger.sku}</h3>
                                <a href="#" class="ego-c-register-purchase__img-link js-purchase-modal-link ego-c-link">${serialNumberCopyCharger}</a>
                                <div class="js-purchase-modal-content">
                                    <img src="${charger.serial_number_location_image}" alt="${charger.name}">
                                </div>                                
                                <div class="field">
                                    <div>
                                        <label for="serial-${charger.serial_number_prefix + index}" class="ego-form-group__serial-number-prefix">${charger.serial_number_prefix}</label>
                                        <input type="text" class="ego-c-register-purchase__input full charger_serial_input required serial-${charger.sku}" id="serial-${charger.serial_number_prefix + index}" sku="${charger.sku}" serial="${charger.serial_number_prefix}" name="charger-serial-${index}" required maxlength="11" minlength="9">
                                        <img src="https://cdn.shopify.com/s/files/1/0689/6556/4654/files/icon-scan.svg?v=1725553364" alt="Scan Icon" class="ego-c-register-purchase__input-scan" data-sku="${charger.sku}" loading="lazy">
                                    </div>
                                </div> 
                            </div>
                        `;
                    $(".product-serial-data").append(charger_template);
                    chargerRegistrationSku = charger.sku;
                });

                if (chargers.length > 1 && !sameChargerSku) { //hide charger forms on load so user can pick with radio button
                    $('.charger-form-container').hide();
                    $('.charger-form-container').find('.charger_serial_input').removeClass('required').removeAttr('required');
                }

                // Hides/shows charger form clicked with radio button
                $("#ego-c-register-radio-container-charger .btn").click(function (e) {
                    $("#ego-c-register-radio-container-charger .btn").removeClass("active");
                    $(this).addClass("active");
                    let thisId = $(this).find('input').attr('id');
                    $('.charger-form-container').hide();
                    $('.charger-form-container').find('.charger_serial_input').removeClass('required').removeAttr('required');

                    if ($('.charger-form-container.' + thisId)[0]) {
                        $('.charger-form-container.' + thisId).show();
                        $('.charger-form-container.' + thisId).find('.charger_serial_input').addClass('required').attr('required');
                    }
                });
            }

            registerProdGoNext(e);

            addGtmTracking("registration_step", 2);
            qrFunctionality();
        });

        /**************/
        /* Datepicker */
        /**************/
        if ($("#datepicker").length) {
            $('#datepicker').mask('00/00/0000'); //using as a fallback incase the datepicker is not loading.
            datepicker('#datepicker', {
                maxDate: new Date(),
                customDays: [window.theme.custom.global.days.sun, window.theme.custom.global.days.mon, window.theme.custom.global.days.tue, window.theme.custom.global.days.wed, window.theme.custom.global.days.thu, window.theme.custom.global.days.fri, window.theme.custom.global.days.sat],
                customMonths: [window.theme.custom.global.months.january.full, window.theme.custom.global.months.february.full, window.theme.custom.global.months.march.full, window.theme.custom.global.months.april.full, window.theme.custom.global.months.may.full, window.theme.custom.global.months.june.full, window.theme.custom.global.months.july.full, window.theme.custom.global.months.august.full, window.theme.custom.global.months.september.full, window.theme.custom.global.months.october.full, window.theme.custom.global.months.november.full, window.theme.custom.global.months.december.full],
                customOverlayMonths: [window.theme.custom.global.months.january.abbr, window.theme.custom.global.months.february.abbr, window.theme.custom.global.months.march.abbr, window.theme.custom.global.months.april.abbr, window.theme.custom.global.months.may.abbr, window.theme.custom.global.months.june.abbr, window.theme.custom.global.months.july.abbr, window.theme.custom.global.months.august.abbr, window.theme.custom.global.months.september.abbr, window.theme.custom.global.months.october.abbr, window.theme.custom.global.months.november.abbr, window.theme.custom.global.months.december.abbr],
                overlayPlaceholder: window.theme.custom.global.four_digit_year,
                overlayButton: window.theme.custom.global.submit,
                formatter: (input, date, instance) => {
                    const dd = String(date.getDate()).padStart(2, '0');
                    const mm = String(date.getMonth() + 1).padStart(2, '0');
                    const yyyy = date.getFullYear();
                    input.value = mm + '/' + dd + '/' + yyyy;
                },
                onSelect: (instance) => {
                    $("#purchase-form").validate().element(instance.el);
                }
            });
        }

        $('.js-register-back').on('click', function (e) {
            e.preventDefault();
            let currentActive = $('.js-register-step.active'),
                currentActiveIndex = $('.js-register-step.active').index() + 1;
            if (currentActiveIndex > 1) {
                $('.js-register-step').removeClass('active');
                currentActive.prev().addClass('active');
            }
            if ($('.js-register-step.active').index() + 1 == 1) {
                $('.js-register-back').removeClass('active');
            }
            $('.ego-c-register-radio').remove(); // REMOVE BATTERY RADIO BUTTONS INCASE USE CLICK ON A DIFFERENT PRODUCT THAT DOES NOT USE THAT FUNCTIONALITY

            addGtmTracking("registration_step", currentActiveIndex);
        });

        // Upload Files Input
        $('#receipt-file.ego-file-input').each(function () {
            let $input = $(this),
                $label = $input.next('label'),
                labelVal = $label.html();

            $input.on('change', function (e) {
                let fileName = '';
                if (e.target.value)
                    fileName = e.target.value.split('\\').pop();
                if (fileName) $label.find('span').html(fileName);
                else $label.html(labelVal);
                $("#purchase-form").validate().element(this);
            });
        });

        $('.js-purchase-receipt').on('selectmenuchange', function (e) {
            if ($(this).val() === 'I Have My Receipt') {
                $('.js-receipt-file').addClass('active');
                $(".ego-c-register-purchase-receipt-message").hide();
            } else {
                $('.js-receipt-file').removeClass('active');
                $(".ego-c-register-purchase-receipt-message").show();
            }
        });

        $('.js-purchase-place').on('selectmenuchange', function (e) {
            if ($(this).val() === 'Other') {
                $('.js-purchase-place-other').addClass('active');
            } else {
                $('.js-purchase-place-other').removeClass('active');
            }
        });

        /**************************/
        /* Register Product Modal */
        /**************************/
        $('body').on('click', '.js-purchase-modal-link', function (e) {
            e.preventDefault();
            $("#js-purchase-modal div").append($(this).next().html());
            $("#js-purchase-modal").modal({clickClose: false});
        });

        $('#js-purchase-modal').on($.modal.AFTER_CLOSE, function (event, modal) {
            $("#js-purchase-modal div").html("");
        });

        /***********************************/
        /* Product Registration validation */
        /***********************************/
        let requiredErrorMessage = window.theme.custom.global.error.please_enter_only_digits;
        let minLengthErrorMessage = window.theme.custom.global.error.please_enter_number_of_characters;

        $(".js-register-submit").click(function (e) {
            e.preventDefault();

            // prevent double-click spam
            if ($("#purchase-form").data("submitting")) return;

            addGtmTracking("registration_step", 3);
            $("#purchase-form").submit();
        });

        $("#purchase-form").validate({
            errorClass: 'ego-invalid',
            validClass: 'ego-valid',
            errorElement: 'span',
            ignore: [],
            errorPlacement: function (error, element) {
                error.addClass('ego-error-show');
                element.parent().append(error);
            },
            focusInvalid: true,
            invalidHandler: function (event, validator) {
                // if invalid, make sure user can try again
                $("#purchase-form").data("submitting", false);
                $(".js-register-submit").prop("disabled", false).removeClass("is-disabled");

                let headerHeight = $('#header').outerHeight();
                let purchaseDetailsNav = $(window).outerWidth() <= 767 ? $(".js-ego-c-register-line").outerHeight() : 0;

                // Focus the first invalid element
                if (validator.errorList.length > 0) {
                    const firstInvalidElement = $(validator.errorList[0].element);

                    if (firstInvalidElement.attr("id") === "datepicker") {
                        setTimeout(function() {
                            firstInvalidElement.blur();

                            $(".qs-datepicker-container").toggleClass("qs-hidden", false);
                        },1);
                    }

                    $('html,body').scrollTop(firstInvalidElement.parent().offset().top - headerHeight - purchaseDetailsNav);
                }
            },
            rules: {
                'date-of-purchase': {
                    "dateValidation": true
                },
                'receipt-file': {
                    required: {
                        depends: function (element) {
                            return $(".js-purchase-receipt").val() === 'I Have My Receipt';
                        }
                    }
                },
                'enter-place-of-purchase': {
                    "placeOfPurchaseValidation": true,
                    "preventHTML": true
                },
                'batteryOptions': {
                    required: true
                },
                'chargerOptions': {
                    required: true
                },
                'product-serial': {
                    "alphanumeric": true
                },
                'product-serial-0': {
                    "alphanumeric": true
                },
                'product-serial-1': {
                    "alphanumeric": true
                },
                'product-serial-2': {
                    "alphanumeric": true
                },
                'product-serial-3': {
                    "alphanumeric": true
                },
                'product-serial-4': {
                    "alphanumeric": true
                },
                'product-serial-5': {
                    "alphanumeric": true
                },
                'battery-serial-0': {
                    "alphanumeric": true
                },
                'battery-serial-1': {
                    "alphanumeric": true
                },
                'battery-serial-2': {
                    "alphanumeric": true
                },
                'battery-serial-3': {
                    "alphanumeric": true
                },
                'battery-serial-4': {
                    "alphanumeric": true
                },
                'battery-serial-5': {
                    "alphanumeric": true
                },
                'charger-serial-0': {
                    "alphanumeric": true
                },
                'charger-serial-1': {
                    "alphanumeric": true
                },
                'charger-serial-2': {
                    "alphanumeric": true
                },
                'charger-serial-3': {
                    "alphanumeric": true
                },
                'charger-serial-4': {
                    "alphanumeric": true
                },
                'charger-serial-5': {
                    "alphanumeric": true
                },
            },
            messages: {
                'receipt-option': window.theme.custom.global.error.required,
                'date-of-purchase': window.theme.custom.global.error.date_validation,
                'place-of-purchase': window.theme.custom.global.error.enter_pop,
                'residential-commercial': window.theme.custom.global.error.required,
                'receipt-file': window.theme.custom.global.error.required,
                'product-serial': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'product-serial-0': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'product-serial-1': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'product-serial-2': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'product-serial-3': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'product-serial-4': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'product-serial-5': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'battery-serial-0': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'battery-serial-1': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'battery-serial-2': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'battery-serial-3': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'battery-serial-4': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'battery-serial-5': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'charger-serial-0': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'charger-serial-1': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'charger-serial-2': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'charger-serial-3': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'charger-serial-4': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'charger-serial-5': {
                    required: requiredErrorMessage,
                    minlength: minLengthErrorMessage
                },
                'batteryOptions': {
                    required: "Please select a battery"
                },
                'chargerOptions': {
                    required: "Please select a charger"
                }
            },
            submitHandler: function (form) {
                const $form = $(form);
                const $btn = $(".js-register-submit");

                // ADD: global guard (covers Enter submit, rapid clicks, etc.)
                if ($form.data("submitting")) return false;
                $form.data("submitting", true);
                $btn.prop("disabled", true).addClass("is-disabled");

                loadingMask("show");
                //Form to array
                let data = $form.serializeArray();

                try {
                    //Is this a kit?
                    let kit = step3.bundle_sku ? "TRUE" : "FALSE";

                    //Purchase date
                    let pdate = data[4].value.split('/');

                    pdate[2] = pdate[2].substring(2);
                    pdate = pdate.join('');

                    let currentUser = JSON.parse(localStorage.getItem('currentUser'));

                    getApiPath('warranty/register?customer_id=' + getCookie('__uid')).then(function (apiPath) {
                        let warranty = {
                            "receipt_status": data[0].value,
                            "receipt_url": data[1].value,
                            "place_of_purchase": data[2].value === "Other" ? data[3].value : data[2].value,
                            "purchase_date": pdate,
                            "product_use_type": data[5].value,
                            "kit": kit,
                            "master_model_number": step3.sku,
                            "warranty_items": [],
                            "brand_name": "EGO",
                            user_info: {
                                auth: "Bearer " + getCookie('__auth'),
                                brand_name: 'EGOC',
                                first_name: currentUser ? currentUser.firstName : "",
                                last_name: currentUser ? currentUser.lastName : "",
                                method: "POST",
                                url: apiPath,
                                event_type: "hs_registration",
                                event_registration_type: eventRegistrationType,
                                email_address: currentUser ? currentUser.email : "",
                                hs_language: $("#hs-language-footer").val(),
                                page_uri: window.location.href,
                                product_category: $(".ego-c-register-step1 .js-register-product.active").data("category"),
                                hs_id: hsId,
                                hs_first_name: hsFirstName,
                                hs_last_name: hsLastName,
                                store_id: "1", //defaulting to EGO US
                                store_locale: Shopify.locale,
                                country: country,
                                region: locationInfo.Region
                            }
                        }

                        data.forEach(function (obj, index) {
                            if (obj.name.includes("product-serial")) {
                                let sku = $("input[name='" + obj.name + "']").attr('sku');
                                let serial = $("input[name='" + obj.name + "']").attr('serial');
                                let product = getObj('sku', sku);

                                warranty.warranty_items.push({
                                    "product_name": product.name,
                                    "serial_number": serial + obj.value,
                                    "product_model_number": sku,
                                    "product_type": "Product"
                                });
                            }
                        });

                        //ADDING BATTERY TO WARRANTY
                        //SEPARATE DUE TO RADIO BUTTON FUNCTIONALITY
                        $.each($('.battery-form-container'), function (index, value) {
                            if ($(value).is(":visible")) {
                                let battery;
                                let batteryInputField = $(value).find('.battery_serial_input');
                                let batteryRegistrationSku = batteryInputField.attr("sku");

                                // if (multipleBatteriesToRegister) {
                                //     batteryRegistrationSku = $('#ego-c-register-radio-container-battery .btn-secondary.active').text().trim();
                                // }

                                battery = getObj('sku', batteryRegistrationSku);

                                warranty.warranty_items.push({
                                    "product_name": battery.name,
                                    "serial_number": battery.serial_number_prefix + batteryInputField.val(),
                                    "product_model_number": batteryRegistrationSku,
                                    "product_type": "Battery",
                                });
                            }
                        });

                        //ADDING CHARGER TO WARRANTY
                        //SEPARATE DUE TO RADIO BUTTON FUNCTIONALITY
                        $.each($('.charger-form-container'), function (index, value) {
                            if ($(value).is(":visible")) {
                                let _charger;
                                let chargerInputField = $(value).find('.charger_serial_input');
                                let chargerRegistrationSku = chargerInputField.attr("sku");

                                // if (multipleChargersToRegister) {
                                //     chargerRegistrationSku = $('#ego-c-register-radio-container-charger .btn-secondary.active').text().trim();
                                // }

                                _charger = getObj('sku', chargerRegistrationSku);

                                warranty.warranty_items.push({
                                    "product_name": _charger.name,
                                    "serial_number": _charger.serial_number_prefix + chargerInputField.val(),
                                    "product_model_number": chargerRegistrationSku,
                                    "product_type": "Charger"
                                });
                            }
                        });

                        $.ajax({
                            method: 'POST',
                            url: apiURL + "rest/all/V1/chervon/proxy/account-processing/",
                            data: JSON.stringify(warranty),
                            contentType: 'application/json',
                            headers: {
                                "Authorization": "Bearer " + getCookie('__acAuth')
                            },
                        })
                            .done(function (data) {
                                data = JSON.parse(data);
                                // proxy success
                                if (data.success) {//middleware success
                                    loadingMask("hide");
                                    registerProdGoNext();

                                    let productList = "";

                                    $(warranty.warranty_items).each(function (i, obj) {
                                        productList += productList ? "," + obj.product_model_number : obj.product_model_number;
                                    });

                                    window.dataLayer.push({
                                        'event': 'registration_complete',
                                        'registration_data': {
                                            'component_sku': productList,
                                            'product_category': warranty.user_info.product_category,
                                            'product_sku': warranty.master_model_number,
                                            'product_use': warranty.product_use_type,
                                            'purchased_date': $("#datepicker").val(),
                                            'purchased_from': warranty.place_of_purchase,
                                            'source': eventRegistrationType,
                                        }
                                    });

                                    if (qrregsku) {
                                        setCookie('qrLocale', Shopify.locale, 1);
                                    }

                                    if (data.hasOwnProperty("hubspotResponse") &&
                                        data.hubspotResponse.hasOwnProperty("body") &&
                                        data.hubspotResponse.body.hasOwnProperty("results") &&
                                        data.hubspotResponse.body.results.length > 0) {
                                        let hubspotData = data.hubspotResponse.body.results[0];

                                        setCookie('__hsID', hubspotData.id, 365, true);

                                        if (hubspotData.properties.firstname) {
                                            setCookie('__hsFirstName', hubspotData.properties.firstname, 365, true);
                                        } else {
                                            setCookie('__hsFirstName', currentUser ? currentUser.firstName : "", 365, true);
                                        }

                                        if (hubspotData.properties.lastname) {
                                            setCookie('__hsLastName', hubspotData.properties.lastname, 365, true);
                                        } else {
                                            setCookie('__hsLastName', currentUser ? currentUser.lastName : "", 365, true);
                                        }
                                    }
                                } else { //middleware failure
                                    if (data.hasOwnProperty("message") &&
                                       data.message.hasOwnProperty("body")) {
                                        if (data.message.hasOwnProperty("status")) {
                                            if (data.message.status === "457") {
                                                let serialValidationData = data.message.body;

                                                $(".product-serial-data .ego-c-register-purchase__input:visible").each(function (i, obj) {
                                                    if (serialValidationData[i].isValidation === false) {
                                                        let errorMessage = window.theme.custom.product_registration.error.duplicate_serial_number;
                                                        let _obj = $(obj);
                                                        let objName = _obj.attr("name");

                                                        $(`[name="${objName}"]`).valid();
                                                        $(`[name="${objName}"]`).closest("form").validate().showErrors({
                                                            [objName]: errorMessage
                                                        });
                                                    }
                                                });

                                                loadingMask("hide");
                                            } else {
                                                errorNotify("Salesforce Serial Number Duplication Check Error: " + data, warranty);
                                                alert(window.theme.custom.product_registration.error.unable_to_complete_registration);
                                                logout();
                                                // loadingMask("hide");
                                            }
                                        } else if (data.message.body.hasOwnProperty("status") &&
                                           data.message.body.hasOwnProperty("message")) {
                                            if (data.message.body.status !== "401") {
                                                errorNotify("Heroku - Unable to complete product registration 1: " + data.message.body.message, warranty);
                                            } else {
                                                errorNotify("Heroku - Unable to complete product registration 2: " + data, warranty);
                                            }

                                            alert(window.theme.custom.product_registration.error.unable_to_complete_registration);
                                            logout();
                                            // loadingMask("hide");
                                        } else {
                                            errorNotify("Heroku - Unable to complete product registration 3: " + data, warranty);
                                            alert(window.theme.custom.product_registration.error.unable_to_complete_registration);
                                            logout();
                                            // loadingMask("hide");
                                        }
                                    }
                                }

                                // allow retry on server-declared failure
                                $form.data("submitting", false);
                                $btn.prop("disabled", false).removeClass("is-disabled");
                            })
                            .fail(function (error) {
                                alert(window.theme.custom.product_registration.error.unable_to_complete_registration);
                                errorNotify('Proxy - EGO Registration Failure: ' + error.responseText);

                                // allow retry on server-declared failure
                                $form.data("submitting", false);
                                $btn.prop("disabled", false).removeClass("is-disabled");

                                loadingMask("hide");
                            });
                    }).catch(function (err) {
                        alert(window.theme.custom.global.error.generic_error);
                        errorNotify('Ego Commercial warranty/register?customer_id= Promise Catch: ' + err);
                        logout();
                    });
                } catch (error) {
                    errorNotify('Product Registration Error', error + " for sku " + $(".ego-c-register-step3-data .ego-subtitle").html());
                    alert(window.theme.custom.product_registration.error.unable_to_complete_registration);
                    logout();
                }

                return false;
            }
        });

        //Jump to final step of registration for Automated testing
        if (_registrationstep1Id && _registrationstep2Id) {
            //Checks the category based off catid
            $(".ego-c-register-step1 .js-register-product#" + _registrationstep1Id).addClass("active").find(".js-register-radio").prop("checked", true);
            $(".js-register-next-step1").click();
            setTimeout(function () {
                $(".ego-c-register-step2").find(".js-register-product#" + _registrationstep2Id).addClass("active").find(".js-register-radio").prop("checked", true);
                $(".js-register-next-step2").click();
            }, 300);
        }

        function addGtmTracking(stepName, stepCount) {
            //prevents tracking if from the automated testing
            if (_allowRegistrationStepTracking) {
                window.dataLayer.push({
                    'event': stepName,
                    'registration_step': stepCount
                });
            }
        }

        function processQRAutoProcess() {
            if (qrregsku) {
                qrScanSelectionModal(getScannedToolInfo());
            } else {
                _registrationstep1Id = getUrlParameter('step1id');
                _registrationstep2SKU = getUrlParameter('step2sku');
                autoStepRegistrationProcessSKU();
            }
        }

        let productFoundEmailSent = false;
        function selectStepBySku(_step, _id) {
            let productFound = false;

            $(".ego-c-register-step" + _step + " .ego-c-register-item.js-register-product").each(function (i, obj) {
                let _obj = $(obj);
                let productItemDataSku = _obj.data("sku");
                if (productItemDataSku) {
                    productItemDataSku = productItemDataSku.split(",");

                    $(productItemDataSku).each(function (pIDSI, pIDSObj) {
                        if (pIDSObj === _id) {
                            productFound = true;
                            $(".ego-c-register-step" + _step).find(".js-register-product#" + _obj.attr("id")).addClass("active").find(".js-register-radio").prop("checked", true);
                            $(".js-register-next-step" + _step).click();
                            return false;
                        }
                    });
                }
            });

            if (!productFound && !productFoundEmailSent) {
                productFoundEmailSent = true;
                errorNotify("EGO C: Scanned Product Not Found: Step: " + _step + ", SKU: " + _id, "Please check the SKU and make sure it is set to registration data use only or is part of a kit.");
            }
        }

        /***********************************************************/
        /* Get Scanned Product Image/Name & Get All Kit components */
        /***********************************************************/
        let batteryInKit = false;
        let chargerInKit = false;

        function getScannedToolInfo() {
            let scannedSkuInfo = {
                productInfo: {},
                kitInfo: []
            };

            for (let cat = 0; cat < EGO_REGISTER_DATA.length; cat++) {
                for (let prod = 0; prod < EGO_REGISTER_DATA[cat].products.length; prod++) {

                    // If the product is found at the product level (step 2) then grab the name and image from here. If not then there is most likely an error in the database that needs addressed
                    if (EGO_REGISTER_DATA[cat].products[prod].sku === qrregsku && $.isEmptyObject(scannedSkuInfo.productInfo)) {

                        let toolName = EGO_REGISTER_DATA[cat].products[prod].name.toLowerCase();
                        toolName = toolName.replace("(", "").replace(")", "").replace("tool only", "").toUpperCase();

                        scannedSkuInfo["productInfo"] = {
                            name: toolName,
                            image: EGO_REGISTER_DATA[cat].products[prod].image,
                            sku: EGO_REGISTER_DATA[cat].products[prod].sku,
                            registrationDataUseOnly: EGO_REGISTER_DATA[cat].products[prod].registration_data_use_only,
                            registrationstep1Id: EGO_REGISTER_DATA[cat].id,
                            registrationstep2SKU: EGO_REGISTER_DATA[cat].products[prod].sku
                        }
                    }

                    //prevent checking bare tools for bundle skus
                    if (EGO_REGISTER_DATA[cat].products[prod].bundle_battery || EGO_REGISTER_DATA[cat].products[prod].bundle_charger) {

                        // if the bundle_sku matches and the product is set to Catalog, Search then we need to grab this product and the crosssells associated with it and add to the kitInfo dropdown
                        let bundleSkus = EGO_REGISTER_DATA[cat].products[prod].bundle_sku.replace(/ /g, '');
                        let bundleBatteries = EGO_REGISTER_DATA[cat].products[prod].bundle_battery.replace(/ /g, '');
                        let bundleChargers = EGO_REGISTER_DATA[cat].products[prod].bundle_charger.replace(/ /g, '');
                        bundleSkus = bundleSkus.split(",");
                        bundleBatteries = bundleBatteries.split(",");
                        bundleChargers = bundleChargers.split(",");

                        $(bundleSkus).each(function (i, obj) {
                            if (obj === qrregsku) {
                                //parent kit
                                if (!$.isEmptyObject(scannedSkuInfo.kitInfo)) {
                                    //prevent adding dups
                                    let found = false;

                                    $.grep(scannedSkuInfo["kitInfo"], function (e) {
                                        if (e.sku === EGO_REGISTER_DATA[cat].products[prod].sku) {
                                            found = true;
                                        }
                                    });

                                    if (!found) {
                                        scannedSkuInfo["kitInfo"][scannedSkuInfo["kitInfo"].length] = {
                                            name: EGO_REGISTER_DATA[cat].products[prod].name,
                                            sku: EGO_REGISTER_DATA[cat].products[prod].sku,
                                            registrationstep1Id: EGO_REGISTER_DATA[cat].id,
                                            registrationstep2SKU: EGO_REGISTER_DATA[cat].products[prod].sku
                                        }
                                    }
                                } else {
                                    //if kitinfo is empty go ahead and add
                                    scannedSkuInfo["kitInfo"][scannedSkuInfo["kitInfo"].length] = {
                                        name: EGO_REGISTER_DATA[cat].products[prod].name,
                                        sku: EGO_REGISTER_DATA[cat].products[prod].sku,
                                        registrationstep1Id: EGO_REGISTER_DATA[cat].id,
                                        registrationstep2SKU: EGO_REGISTER_DATA[cat].products[prod].sku
                                    }
                                }
                            }
                        });

                        if (!batteryInKit && !chargerInKit) {
                            $(bundleBatteries).each(function (i, obj) {
                                if (obj === qrregsku) {
                                    batteryInKit = true;
                                }
                            });

                            $(bundleChargers).each(function (i, obj) {
                                if (obj === qrregsku) {
                                    chargerInKit = true;
                                }
                            });
                        }
                    }
                }
            }

            return scannedSkuInfo;
        }

        /***********************************/
        /* QR Code - Register another tool */
        /***********************************/
        function qrFunctionality() {
            if (navigator.userAgent.match(/Android/i) ||
                navigator.userAgent.match(/webOS/i) ||
                navigator.userAgent.match(/iPhone/i) ||
                navigator.userAgent.match(/iPad/i) ||
                navigator.userAgent.match(/iPod/i) ||
                navigator.userAgent.match(/BlackBerry/i) ||
                navigator.userAgent.match(/Windows Phone/i) ||
                (navigator.userAgent.match(/Macintosh/i) && typeof navigator.standalone !== "undefined") ||
                (qrregsku)) {
                // show the serial number field QR scan icon
                $(".ego-c-register-purchase__input-scan").addClass("active");

                // the user is using a mobile device or came from a qr code, so show the qr code button and the icon on the serial number fields to scan the next serial number
                $(document).on("click", ".ego-c-register-purchase__input-scan", function (e) {
                    e.preventDefault();

                    if ($(this).hasClass("ego-c-register-purchase__input-scan")) {
                        qrModalSettings.type = "scan only";
                        qrModalSettings.field = $(this);
                        qrScanModal(true, true);
                    }
                });
            }
        }

        if (qrregsku) {
            // the user is using a mobile device or came from a qr code, so show the qr code button and the icon on the serial number fields to scan the next serial number
            $(document).on("click", "#ego-c-register-qr, .ego-c-qr-selection-modal-bc-error-btn", function (e) {
                e.preventDefault();

                if ($(this).hasClass("ego-c-qr-selection-modal-bc-error-btn")) {
                    qrModalSettings.type = "different kit registration";
                    qrModalSettings.field = "";
                    qrScanModal(true, true);
                } else {
                    qrModalSettings.type = "new registration";
                    qrModalSettings.field = "";
                    qrScanModal(true, true);
                }
            });
        }

        /*************/
        /* QR Modals */
        /*************/
        let html5QrCode = new Html5Qrcode("reader");
        let config = { fps: 10, qrbox: { width: 290, height: 290 } };
        let qrModal = $("#ego-c-qr-modal");
        let qrModalSettings = {
            type: "",
            field: ""
        }

        async function qrScanModal(closeModal, clearCookies) {
            const permissionGranted = await requestCameraPermission();
            if (permissionGranted) {
                if (closeModal) {
                    $.modal.close();

                    setTimeout(function () {
                        qrModal.modal({clickClose: false});
                    }, 300);
                } else {
                    setTimeout(function () {
                        qrModal.modal({clickClose: false});
                    }, 300);
                }
            } else {
                alert(window.theme.custom.product_registration.allow_camera_access);
            }
        }

        async function requestCameraPermission() {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                stream.getTracks().forEach(track => track.stop()); // Close the stream after testing
                return true; // Permission granted
            } catch (error) {
                console.error("Camera permission denied:", error);
                return false;
            }
        }

        qrModal.on($.modal.BEFORE_OPEN, function () {
            const qrCodeSuccessCallback = (decodedText, decodedResult) => {
                html5QrCode.stop().then((ignore) => {
                    //scan successful
                    if (qrModalSettings.type === "scan only") {
                        let _decodedTextSku = getUrlParameterFromVariable("m", decodedText);
                        let _decodedTextSN = getUrlParameterFromVariable("s", decodedText);

                        if (_decodedTextSku && _decodedTextSN) {
                            _decodedTextSku = _decodedTextSku.toUpperCase();
                            _decodedTextSN = _decodedTextSN.toUpperCase().slice(5);

                            let scannedSkuFoundInKit = false;

                            // verify that the sku scanned is for the field the scan was triggered for - matches the skus from the scan vs the sku form the scan icon data-sku attribute
                            qrModalSettings.field.closest(".product-serial-data").find(".field").each(function(i, obj) {
                                let _obj = $(obj);
                                let serialNumberField = _obj.find(".ego-c-register-purchase__input");

                                if (serialNumberField.attr("sku") === _decodedTextSku) {
                                    // add matching sku to first available/matching option not already filled in.
                                    scannedSkuFoundInKit = true;

                                    if (serialNumberField.val() === _decodedTextSN) {
                                        alert(window.theme.custom.product_registration.serial_number_already_added);
                                        return false;
                                    } else if (serialNumberField.val() === "") {
                                        serialNumberField.val(_decodedTextSN);
                                        $("#purchase-form").validate().element(serialNumberField);
                                        return false;
                                    }
                                }
                            });

                            // scanned sku not found in the selected kit
                            if (!scannedSkuFoundInKit) {
                                alert(window.theme.custom.product_registration.not_part_of_kit);
                                errorNotify('Error: This product is not a part of the kit that you selected to register.', "Product selected for registration: " + $(".ego-c-register-step3-data .ego-subtitle").html() + ", Scanned SKU: " + decodedText);
                            }
                        } else {
                            alert(window.theme.custom.product_registration.serial_number_missing_input_field);
                        }

                        $.modal.close();
                    } else if (qrModalSettings.type === "new registration") {
                        //retain the users selected info to pre-populate
                        if (qrregsku) {
                            setUserRegistrationData();
                        }

                        $("#reader").fadeOut(function() {
                            $(".ego-c-qr-modal-success").fadeIn();
                            //proceed to QR code location
                            window.location.replace(decodedText);
                        });
                    } else if (qrModalSettings.type === "different kit registration") {
                        $("#reader").fadeOut(function() {
                            $(".ego-c-qr-modal-success").fadeIn();
                            //proceed to QR code location
                            window.location.replace(decodedText);
                        });
                    }
                }).catch((err) => {
                    errorNotify('Error: Stopping QR Code Scanner QR Scanned', err);
                });
            };

            html5QrCode.start({ facingMode: "environment" }, config, qrCodeSuccessCallback).catch(err => {
                console.error("Back camera not available, attempting front camera...");
                html5QrCode.start({ facingMode: "user" }, config, qrCodeSuccessCallback).catch(innerErr => {
                    console.error("Error starting QR scanner:", innerErr);
                    alert("Unable to start QR scanner. Please check your camera permissions or try again.");
                });
            });
        });

        function setUserRegistrationData() {
            let purchaseReceipt = $(".js-purchase-receipt").val();
            setCookie('qrregreceipt', purchaseReceipt, (1/24) * .25, true);

            if (purchaseReceipt === "I Have My Receipt") {
                let qrregreceiptpth = $("#receipt-file").val();
                qrregreceiptpth = qrregreceiptpth.replace("https://cdn.filestackcontent.com/", "");
                setCookie('qrregreceiptpth', btoa("egorcpth" + qrregreceiptpth), (1/24) * .25, true); // 15 minute cookie
            }

            let jsPurchasePlace = $(".js-purchase-place").val();
            setCookie('qrregplace', $(".js-purchase-place").val(), (1/24) * .25, true);

            if (jsPurchasePlace === "Other") {
                setCookie('qrregplaceother', $(".js-purchase-place-other input").val(), (1/24) * .25, true);
            }

            setCookie('qrregdate', $("#datepicker").val(), (1/24) * .25, true);
            setCookie('qrreguse', $(".js-purchase-use").val(), (1/24) * .25, true);
        }

        qrModal.on($.modal.AFTER_CLOSE, function () {
            if (html5QrCode.isScanning) {
                html5QrCode.stop().then((ignore) => {
                    // QR Code scanning is stopped.
                }).catch((err) => {
                    errorNotify('Error: Stopping QR Code Scanner QR Not Scanned', err);
                });
            }
        });

        $(document).on("click", "#ego-c-qr-modal-close", function (e) {
            e.preventDefault();
            $.modal.close();
        });

        let qrSelectionModal = $("#ego-c-qr-selection-modal");

        $(document).on("click", "#ego-c-qr-selection-close", function (e) {
            e.preventDefault();
            $.modal.close();
        });

        function qrScanSelectionModal(scannedSkuInfo) {
            let isBareToolRegisterableToolOnly = false;

            if (scannedSkuInfo.productInfo.registrationDataUseOnly !== "1") {
                isBareToolRegisterableToolOnly = true;
            }

            if (scannedSkuInfo.productInfo.sku) { // for scanned QR Codes: loads selection modal since product is part of a kit
                $(".ego-c-qr-selection-modal-product-image").attr("src", scannedSkuInfo.productInfo.image).attr("alt", scannedSkuInfo.productInfo.name);
                $(".ego-c-qr-selection-modal-product-name").html(scannedSkuInfo.productInfo.name);
                $(".ego-c-qr-selection-modal-product-sku").html(scannedSkuInfo.productInfo.sku);

                if (isBareToolRegisterableToolOnly) {
                    $(".ego-c-qr-selection-modal-selection[data-option='tool']").addClass("active"); //make the tool only selection active on modal load
                } else {
                    $(".ego-c-qr-selection-modal-selection[data-option='tool']").hide(); //tool only not registerable, hide tool only selection
                    $(".ego-c-qr-selection-modal-selection[data-option='kit']").addClass("active"); //make the kit the active selection
                }

                if ($.isEmptyObject(scannedSkuInfo.kitInfo)) {
                    $(".ego-c-qr-selection-modal-selection[data-option='kit']").hide();
                    // $(".ego-c-qr-selection-modal-bc-error").addClass("active");
                } else {
                    // if (batteryInKit || chargerInKit) {
                    //     $(".ego-c-qr-selection-modal-bc-error").addClass("active");
                    //     $("#ego-c-qr-selection-modal-select option:first").text(window.theme.custom.product_registration.battery_charger_only_kit);
                    // }
                }

                if (batteryInKit || chargerInKit) {
                    $(".ego-c-qr-selection-modal-bc-error").addClass("active");
                    $("#ego-c-qr-selection-modal-select option:first").text(window.theme.custom.product_registration.battery_charger_only_kit);
                }

                // ego-c-qr-selection-modal-selection
                $.each(scannedSkuInfo.kitInfo, function (i, item) {
                    $('#ego-c-qr-selection-modal-select').append($('<option>', {
                        value: item.registrationstep1Id + "," + item.registrationstep2SKU,
                        text : item.sku + ": " + item.name.replace("<br>", "")
                    }));
                });

                $('.ego-c-qr-selection-modal-selection-dropdown').selectmenu({
                    appendTo: $(".ego-c-qr-selection-modal-selection[data-option='kit']"),
                    "position": {
                        my: "left top",
                        at: "left bottom",
                        collision: "flip"
                    }
                });

                qrSelectionModal.modal({clickClose: false});

                $(".ego-c-qr-selection-modal-submit").click(function (e) {
                    e.preventDefault();
                    let selectedOption = $(".ego-c-qr-selection-modal-selection.active").data("option");

                    if (selectedOption === "tool") {
                        _registrationstep1Id = scannedSkuInfo.productInfo.registrationstep1Id;
                        _registrationstep2SKU = scannedSkuInfo.productInfo.registrationstep2SKU;
                        autoStepRegistrationProcessSKU();
                        $.modal.close();
                    } else if (selectedOption === "kit") {
                        let kitVal = $('#ego-c-qr-selection-modal-select').val();

                        if (kitVal) {
                            let _kitVal = kitVal.split(",");
                            _registrationstep1Id = _kitVal[0];
                            _registrationstep2SKU = _kitVal[1];
                            autoStepRegistrationProcessSKU();
                            $.modal.close();
                        } else if (!$(".ego-c-qr-selection-modal-selection[data-tool='tool']").is(":visible")) {
                            $("#ego-c-qr-selection-tool-form .error").html(window.theme.custom.product_registration.please_choose_a_kit_from_the_dropdown_list).show();
                        } else {
                            $("#ego-c-qr-selection-tool-form .error").html(window.theme.custom.product_registration.kit_or_bare_tool).show();
                        }
                    }
                });

                $(".ego-c-qr-selection-modal-selection").click(function() {
                    $("#ego-c-qr-selection-tool-form .error").hide();
                    $(".ego-c-qr-selection-modal-selection").removeClass("active");
                    $(this).addClass("active");
                });
            } else {
                // Tool not found
                errorNotify("Error - EGO Commercial: Scanned Tool Not Found. SKU:" + qrregsku);
            }
        }

        //Jump to final step of registration for Automated testing
        function autoStepRegistrationProcessSKU() {
            if (_registrationstep1Id && _registrationstep2SKU) {
                if (!qrregsku) { //allow tracking for QR Registrations but not automated testing
                    _allowRegistrationStepTracking = false;
                }

                //Checks the category based off catid
                $(".ego-c-register-step1 .js-register-product#" + _registrationstep1Id).addClass("active").find(".js-register-radio").prop("checked", true);
                $(".js-register-next-step1").click();
                selectStepBySku("2", _registrationstep2SKU);

                // add previous data back to the users registration
                if (qrregsku) {
                    let placeOfPurchaseCookie = getCookie("qrregplace");
                    let placeOfPurchaseOtherCookie = getCookie("qrregplaceother");
                    let dateOfPurchaseCookie = getCookie("qrregdate");
                    let residentialOrCommercialCookie = getCookie("qrreguse");

                    if (receiptCookie) {
                        $(".js-purchase-receipt")
                            .val(receiptCookie)
                            .trigger('change')
                            .selectmenu("refresh")
                            .trigger("selectmenuchange");

                        if (receiptCookie === "I Have My Receipt") {
                            // upload previous receipt
                            let qrregreceiptpth = getCookie("qrregreceiptpth");

                            if (qrregreceiptpth) {
                                qrregreceiptpth = atob(qrregreceiptpth);
                                qrregreceiptpth = qrregreceiptpth.replace("egorcpth", "");

                                let receiptFile = $("#receipt-file");
                                $("#receipt-file").val("https://cdn.filestackcontent.com/" + qrregreceiptpth);

                                if (receiptFile.val()) {
                                    $("#receipt-file-name").text(window.theme.custom.product_registration.previous_receipt_uploaded);
                                }
                            }
                        }
                    }

                    if (placeOfPurchaseCookie) {
                        $(".js-purchase-place")
                            .val(placeOfPurchaseCookie)
                            .trigger('change')
                            .selectmenu("refresh")
                            .trigger("selectmenuchange");
                    }

                    if (placeOfPurchaseOtherCookie) {
                        $(".js-purchase-place-other input").val(placeOfPurchaseOtherCookie);
                    }

                    if (dateOfPurchaseCookie) {
                        $("#datepicker").val(dateOfPurchaseCookie);
                    }

                    if (residentialOrCommercialCookie) {
                        $(".js-purchase-use")
                            .val(residentialOrCommercialCookie)
                            .trigger('change')
                            .selectmenu("refresh")
                            .trigger("selectmenuchange");
                    }

                    $(".serial-" + qrregsku).val(qrregsn); //add serial number to field
                }
            }
        }

        $("#thb-language-code-HeaderLocalization, #thb-language-code-FooterLocalization, #thb-language-code-MobileMenuLocalization").change(function() {
            if (qrregsku) {
                setCookie('qrregsku', qrregsku, 1, true);

                if (qrregsn) {
                    setCookie('qrregsn', qrregsn, 1, true);
                }
            }
        });

        function clearQRCookies() {
            deleteCookie('qrregsku', true);
            deleteCookie('qrregsn', true);
            deleteCookie('qrregreceipt', true);
            deleteCookie('qrregplace', true);
            deleteCookie('qrregplaceother', true);
            deleteCookie('qrregdate', true);
            deleteCookie('qrreguse', true);
            deleteCookie('qrregreceiptpth', true);
        }
    }

    // remove disabled attribute from account buttons once JS is loaded
    $("#customer_login .ego-c-btn, #create_customer .ego-c-btn, #customer_forgot .ego-c-btn, #form-reset .ego-c-btn").removeAttr("disabled");
});